

const en = {
    outlookPromo: {
        skip: "Later",
        later: "Continue without installing",
        installCta: "Install the Outlook add-in",
        onboardingTitle: "Work from Outlook too",
        onboardingDescription:
            "Install the Famla add-in to map processes and collaborate without leaving your inbox.",
        mappingTitle: "Your map is ready — and so is Outlook",
        mappingDescription:
            "Install the Famla add-in to reopen processes and flag friction points directly in Outlook.",
        interviewTitle: "Install Famla for Outlook",
        interviewDescription:
            "Thanks for contributing. The Famla Outlook add-in lets you keep collaborating from your mailbox.",
    },
    dashboard: {
        addNewAdmin: "Add new admin",
        addNewUser: "Add new user",
        addNewAdminTitle: "Add new administrator",
        adminAddedSuccessfully: "Administrator added with success.",
        admin: "Administrators",
        andon: "Andon",
        answerDelete: "Are you sure you want to permanently delete this user from the system? This action cannot be undone.",
        dashboard: "Dashboard",
        daysRemaining: "Days remaining",
        deleteUser: "Delete User",
        demoteFromAdmin: "Demote from admin",
        confirmUserDemotion: "Do you really want to promote this user to admin?",
        confirmAdminPromotion: "You are about to promote this user to the Administrator role",
        collaborators: "Collaborators",
        companyNotFound: "Company not found.",
        exitDashboard: "Exit Dashboard",
        exportXls: "Export to Xls",
        lastConnectionDate: "Last connection date",
        list: "list",
        mappingCreationDate: "Mapping Creation Date",
        monthlyTokenConsumption: "Monthly AI Credits Consumption",
        monthlyTokenConsumed: "Monthly AI credits consumed",
        promoteToAdmin: "Promote to admin",
        processOwners: "Process owners",
        remainingTokens: "Remaining Tokens",
        registrationDate: "Registration date",
        shareToAll: "Share to All",
        shareToSelectedUser: "Share to selected users",
        shareWithOtherUsers: "Share with other users",
        successDemotion: "The admin was successfully demoted to user.",
        successPromotion: "The user has been successfully promoted to the Administrator role.",
        users: "Users",
        userAlreadyAdmin: "The user is already an admin.",
        registeredUsers: "Registered users",
        unverifiedUsers: "Unverified users",
        rootUserCannotBeRemoved: "The main administrator cannot be downgraded to a single user.",
        cannotDeleteAdmin: "Cannot delete admin users. Please demote them first.",
        errorDeletingUser: "An error occurred while deleting the user.",
        theSelectedProcessWill: "The selected process(es) will be available to all users within your company",
        theProcessSuccessfullyShared: "The process has been shared with the selected user(s).",
        totalUsers: "Total users",
        totalTokens: "Token",
        tokensConsumed: "Token Consumed",
        // [AI CREDITS SYSTEM] New keys for credits system
        availableCredits: "Available Credits",
        consumedCredits: "Consumed Credits",
        usagePercentage: "Usage",
        monthlyCreditConsumption: "Monthly AI Credits Consumption",
        currentPlan: "Current Plan",
        readOnlyMode: "Read-Only Mode",
        viewPaidPlans: "Manage your plan",
        viewCreditHistory: "View History",
        upgradePlan: "Upgrade Plan",
        enterpriseExpired: "Your ENTERPRISE plan has expired (credits exhausted). Please add credits to continue using the service.",
        freeExpired: "Your FREE plan has expired (credits exhausted). Please add credits to continue using the service.",
        enterpriseMode: "Enterprise Mode",
        proMode: "Pro Mode",
        // Nouvelles clés pour les actions de crédits
        buyMoreCredits: "Buy More Credits",
        changePlan: "Change Plan",
        myInvoices: "My Invoices",
        paymentMethods: "Payment Methods",
        managePlan: "Manage Plan",
        manageSubscription: "Manage Subscription",
        manageSubscriptionMicrosoft: "Manage via Azure Marketplace",
        manageSubscriptionMicrosoftNoUrl: "Your subscription is managed via Azure Marketplace. Contact your Azure administrator or {{appName}} support.",
        // Nouvelles clés pour les statuts
        // [CREDITS PANEL] New translations for credits panel
        freeCredits: "Free Credits",
        monthlyCredits: "Monthly Credits",
        topUpCredits: "Top-up Credits",
        plusTopUpCredits: "Top up credits",
        rolloverCredits: "Roll-over",
        buyMoreCredits: "Buy More Credits",
        manageSubscription: "Manage your Subscription",
        outOf: "out of",
        totalCredits: "credits",
        unlimitedAllocation: "Unlimited Allocation",
        planStatus: "Status",
        statusActive: "Active",
        statusGracePeriod: "Grace Period",
        statusExhausted: "Exhausted",
        statusExpired: "Expired",
        gracePeriodActive: "Grace Period Active",
        // Nouvelles clés pour les types de crédits
        outOf: "out of",
        totalCredits: "credits",
        freeCredits: "Free Credits",
        monthlyCredits: "Monthly Credits",
        topUpCredits: "Purchased Credits",
        plusTopUpCredits: "Top up credits",
        rolloverCredits: "Rollover Credits",
        consultationMode: "Read-Only Mode",
        statusExpired: "Expired",
        refresh: "Refresh",
    }
    ,

    form: {
        nameRequired: "Name is required",
        createCompany: {
            companyName: "Company name",
            createACompany: "Create a company",
            phoneNumber: "Phone number",
            postalCode: "Postal code",
            website: "Website",
            promoCode: "Promo Code",
            promoCodePlaceholder: "Ex: GenAI.works (optional)"
        },
        createGroup: {
            createGroup: "Create Folder",
            folderNameExist: "Folder name already exist",
            groupCreateSuccessfully: "Folder create successfully",
            selectOwner: "Select Owner",
            youNotAuthorized: "You are not authorized to create a folder"
        },
        createProcess: {
            aiLedinterview: "AI-led interview",
            descriptionTooShort: "The description must be at least 5 characters long.",
            humanLedInterview: "Text input",
            industryRequired: "Industry is required",
            invalidSelection: "Invalid industry selection",
            imageBasedMapping: "Image input",
            nameIsNotValid: "The name or description is not valid. 'Test' or 'test' are not accepted.",
            processCannotCreate: "process cannot be create by its user",
            processCreateLimite: "Creation limit reached – please upgrade to Premium to continue.",
            processNameAlreadyExist: "Process name already exist in your company",
            processOverview: "Create a new process",
            processNamePlaceholder: "e.g. Financial reporting",
            descriptionPlaceholder: "Describe what this process achieves and who it serves",
            selectIndustry: "Select Industry",
            selectLanguage: "Select interview language",
            purposePlaceholder: "Describe what this process achieves and who it serves",
            inputMethod: "Input method",
            interviewTextCard: "Interview (text)",
            imageDocumentCard: "Image / document",
            submitProcess: "Create process",
            tabCreate: "Create process",
            tabProcesses: "Library"
        },
        dataCollect: {
            processOverview: "New collection",
            subtitle: "Set up the basics — the conversation starts right after.",
            collectionName: "Collection name",
            collectionNamePlaceholder: "e.g. Financial reporting — data enrichment Q2",
            industryRequired: "Industry is required",
            functionRequired: "Function is required",
            selectIndustry: "Select",
            selectFunction: "Select",
            start: "Start",
            industryLabel: "Industry",
            functionLabel: "Function",
            functions: {
                finance: "Finance",
                hr: "Human Resources (HR)",
                operations: "Operations",
                it: "IT",
                sales: "Sales",
                marketing: "Marketing",
                legal: "Legal",
                other: "Other"
            },
            collectionLanguageLabel: "Collection language",
            collectionLanguageHint:
                "Used for this collection only (setup chat, interview script, contributor experience, emails). Existing collections without a saved language follow the owner profile.",
            collectionLanguageFr: "French",
            collectionLanguageEn: "English"
        },
        collectWorkspace: {
            messageTime: {
                now: "now",
                seconds: "{{count}}s",
                minutes: "{{count}} min",
                hours: "{{count}} h",
                yesterday: "Yesterday · {{time}}"
            },
            listenTitle: "Listen (coming soon)",
            likeTitle: "Like",
            dislikeTitle: "Dislike",
            deleteLastOnly: "Only the latest message can be edited or deleted.",
            editLastOnly: "Only the latest message can be edited.",
            ownerSetupDeleteConfirm:
                "Delete this message and everything after it in this setup chat? This cannot be undone.",
            ownerSetupDeleteFailed: "Could not delete messages. Please try again.",
            waitForReply: "Wait until the reply finishes.",
            editSave: "Save",
            editCancel: "Cancel",
            addContextModalTitle: "Attach context",
            addContextModalHint: "File (PDF, text…) and/or process map.",
            addContextButton: "Attach a file or map",
            contextChoiceInputLockedHint:
                "Use “Attach a file or map” or “Skip for now” above before typing or using voice.",
            contextFileEmpty: "No text could be extracted from this file.",
            contextFileUnsupported: "This file type is not supported. Use PDF, plain text (.txt, .csv, .md), or JSON.",
            contextFileReadError: "Could not read this file. Try another format or paste text in the Interview script tab.",
            contextFileWorking: "Reading file…",
            guideReviewTitle: "Review interview script",
            guideEmpty: "No interview script yet. Finish the Collect conversation or click Regenerate.",
            guideSaveFailed: "Could not save the interview script.",
            guideSectionName: "Section title",
            guideSectionObjective: "Section objective",
            guideQuestionRemoved: "Removed from survey",
            guideRestore: "Restore",
            guideHide: "Remove from survey",
            guideRegen: "Regenerate with AI",
            guideRegenShort: "Regenerate wording",
            guideAiAdaptBanner:
                "{{appName}} will adapt how each question is worded based on role and prior answers — this script lists intents, not fixed recipient wording.",
            deleteSection: "Delete section",
            deleteSectionConfirm: "Remove this entire section and all its questions? This cannot be undone.",
            guideAddQuestion: "Add question",
            guideAddSection: "Add section",
            guideNewSectionDefaultName: "New section",
            guideAddPlaceholder: "Type a new question…",
            guideDragHint: "Drag to reorder sections",
            guideMaxQuestions: "Maximum of 5 questions per section.",
            guideMaxSections: "Maximum of 5 sections per role.",
            navHome: "Home",
            newDataCollection: "New data collection",
            recentDataCollections: "Recent",
            recentDataCollectionsAutoSave: "(Automatic save)",
            recentDataCollectionsEmpty: "No collections yet.",
            recentCollectionRowMenu: "Collection actions",
            renameDataCollectionPrompt: "New collection name",
            deleteDataCollectionConfirm:
                "Delete this draft data collection and all its content? This cannot be undone.",
            deleteDataCollectionConfirmActive:
                "Delete this collection and all responses? This cannot be undone.",
            withdrawMyContribution: "Delete for me",
            withdrawMyContributionConfirm:
                "Remove your contribution from this collection? Your responses and messages will be deleted. The collection will remain visible to the owner.",
            withdrawMyContributionDoneTitle: "Your contribution has been removed",
            withdrawMyContributionDoneBody:
                "Your responses and messages for this collection have been deleted. This invitation link is no longer valid.",
            recipientsTitle: "Recipients",
            noRecipients: "No recipients yet.",
            addRecipient: "Add recipient",
            copyResponderLink: "Copy responder link",
            responderLinkCopied: "Link copied!",
            collectInviteModalTitle: "Add respondent for this role",
            collectInviteModalSubmit: "Add contributor",
            sharedLinkRoleTitle: "Confirm your role",
            sharedLinkRoleHint: "Select the role that best matches you for « {{name}} ».",
            sharedLinkStartInterview: "Start interview",
            sharedLinkPickRole: "Please select your role.",
            sharedLinkInvalid: "Invalid responder link",
            sharedLinkNotOpen: "This collection is not open yet. The owner must approve the script first.",
            sharedLinkNotOpenResponses: "This collection is not open for responses yet.",
            sharedLinkNotApproved: "The interview script is not approved yet.",
            sharedLinkClosed: "This collection is closed.",
            sharedLinkInvalidRole: "The selected role is not valid for this collection.",
            sharedLinkMaxResponders: "The maximum number of respondents has been reached for this collection.",
            generatingGuide: "Generating interview script…",
            typeAnswer: "Type your answer…",
            approveGuideHint:
                "The script is approved.",
            activeCollectionHint:
                "The collection is active.",
            approveRetryHint:
                "Approval could not be completed. Please try again.",
            approvingGuide: "Approving…",
            guideApprovedSuccess:
                "Interview script approved. Copy the responder link or add recipients when you are ready.",
            approveAndPublishSuccess:
                "Script approved. The collection is active and invitations have been sent.",
            approveAndPublishLinkSuccess:
                "Script approved. The collection is active — share the responder link with respondents.",
            approveActivationPending:
                "The script could not be approved. Please try again.",
            collectionActivatedSuccess: "Script approved. Invitation emails have been sent.",
            collectionActivatedLinkSuccess:
                "Script approved. Share the responder link with respondents.",
            approveActivationFailed:
                "The collection could not be activated. Please try again.",
            contextExcerptLabel: "Context excerpt (optional)",
            contextExcerptPlaceholder: "Paste key points from a document…",
            saveContext: "Save context",
            regenerateGuide: "Regenerate interview script (AI)",
            setupNotReadyForScript:
                "Finish setup in the Collect tab (objective, context or maps, and roles) before generating or approving the interview script.",
            setupNotReadyShort: "Complete setup in Collect first.",
            setupNotReadyHint:
                "Answer the remaining setup questions (objective, context, and roles) before you can approve.",
            guideGenerationFailed: "Interview script generation failed",
            approveGuide: "Approve script",
            contributorsTitle: "Contributors",
            selectContributor: "Select a contributor.",
            transcriptTitle: "Transcript",
            checklistTitle: "Your checklist",
            quickActionsTitle: "Quick actions",
            viewAsRecipient: "View as recipient",
            recipientPreviewBadge: "Preview",
            recipientPreviewBanner:
                "Preview — AI-led interview (follow-ups, batched themes). Nothing is saved.",
            recipientPreviewSimulatedRole: "Simulated role",
            recipientPreviewCustomRole: "Or type a role…",
            recipientPreviewRestart: "Restart preview",
            contributorQuestionProgress: "Question {{n}} of {{total}} · {{section}}",
            contributorThemesProgress: "{{covered}} / {{total}} themes covered · {{section}}",
            monitorGuideIntentLabel: "Script intent",
            recipientPreviewIntroOpening:
                "We're glad you're here. For **{{name}}**, {{appName}} walks you through the interview script step by step—just like for contributors once the collection is live.",
            recipientPreviewObjective: "Objective",
            recipientPreviewQuestionLine: "Question {{n}} of {{total}}",
            recipientPreviewNextThanks: "Thank you. Here is the next question.",
            recipientPreviewDone:
                "**You've reached the last question in this guide.** When you go live, {{appName}} continues the conversation here with each contributor. Use **Close** above to return to your workspace and send invitations when you're ready.",
            recipientPreviewCloseHint: "Return to your collection workspace",
            recipientPreviewExportHeader:
                "Preview walkthrough — plain text export only (contributors get an XLSX export from {{appName}}).",
            recipientPreviewEmptyGuide:
                "Generate the interview script with at least one kept question, then you can preview the respondent experience.",
            recipientPreviewNoQuestionsForRole:
                "No kept questions for this role. Choose another role or check the interview script for this role.",
            recipientPreviewLoadError: "Could not load this collection for preview.",
            recipientPreviewBackToWorkspace: "Back to collection",
            publish: "Publish",
            shareLink: "Copy responder link",
            openSynthesis: "Open responses",
            viewInterviewScript: "View interview script",
            viewInterviewScriptEmpty: "Generate or approve the interview script first.",
            exportTranscripts: "Export interview script",
            exportGuideNeedApproved: "Approve the interview script before exporting it as PDF.",
            exportGuidePdfTitle: "Approved interview script",
            exportGuideApprovedStamp: "Approved on {{date}}",
            exportGuideQuestionPrefix: "Q",
            openSettings: "Open settings",
            settingsModal: {
                title: "Collection settings",
                interviewEnd: "Interview end date",
                interviewEndHint: "Optional deadline for completing interviews in this collection.",
                reminderFrequency: "Reminder email frequency",
                reminder6h: "6 hours after invite",
                reminder12h: "12 hours after invite",
                reminder24h: "24 hours after invite",
                reminder48h: "48 hours after invite",
                reminder72h: "72 hours after invite",
                reminder168h: "7 days after invite",
                recipientsCanInvite: "Recipients can invite other recipients",
                anonymousResponses: "Anonymous responses",
                anonymousResponsesHint:
                    "Contributors appear to you as fictitious names (animals or stars). You cannot tell which person matches which name.",
            },
            settingsInvalidDate: "Invalid date",
            announcementsTitle: "Announcements",
            copyLinkError: "Add a contributor first to get an invitation link.",
            copyLinkFail: "Could not copy link.",
            owner: "Owner",
            collectionLead: "Collection Lead",
            participants: "Participants",
            contributorOnlineNow: "Online now",
            contributorOnlineNowEmpty: "No other contributors are shown as online yet.",
            contributorOthers: "Others",
            contributorOnlyYouInList: "No other participants yet.",
            contributorYouPinned: "You",
            contributorDefaultRole: "Contributor",
            contributorStatusNotStarted: "Not started",
            contributorYourProgress: "Your progress",
            contributorProgressStepCount: "{{done}} / {{total}}",
            contributorProgressStepsHint: "{{done}} of {{total}} steps completed",
            contributorSectionCompleted: "{{count}} questions · completed",
            contributorSectionPartial: "{{answered}} / {{total}} questions · in progress",
            contributorShareCopied: "Link copied to clipboard",
            contributorInviteToCollection: "Invite to data collection",
            contributorQuickCreateAccount: "Create a {{appName}} account",
            contributorQuickRecommendFriend: "Recommend {{appName}} to a friend",
            contributorRecommendShareTitle: "{{appName}}",
            contributorRecommendShareText:
                "Try {{appName}} for qualitative research and interviews: {{url}}",
            contributorRecommendEmailSubject: "I thought you might like {{appName}}",
            contributorRecommendEmailBody:
                "Hi,\n\nI've been using {{appName}} for interviews and qualitative research — here's where to sign up:\n{{url}}\n",
            contributorInviteHelp:
                "To invite others, ask the collection owner to add contributors from their {{appName}} workspace.",
            inviteAnotherRecipient: "Invite another recipient",
            sendInvitation: "Send invitation",
            recipientInviteSending: "Sending…",
            recipientInviteValidation: "Name, email and role are required.",
            recipientInviteFailed: "Invitation could not be sent. Please try again.",
            recipientInviteSuccess: "Invitation sent successfully.",
            connectionError: "Connection error",
            recipientInviteSelfEmail: "You cannot invite your own email address.",
            liveSession: "In progress",
            inProgress: "In progress",
            collectionBadgeDraft: "Draft",
            collectionBadgeActive: "Active",
            collectionBadgeClosed: "Closed",
            errorPublishNeedContributors:
                "Add at least one contributor before you can approve the script and send invitations.",
            errorCtaAddRecipient: "Add recipient",
            inviteContributorsHint: "Add at least one contributor to send invitations.",
            publishAfterInviteFailed:
                "Contributors were added but the script could not be approved. Try again.",
            duplicateContributorRole: "{{email}} is already invited for this role.",
            recipientReminderSent: "Reminder email sent.",
            deleteContributorConfirm: "Remove {{name}} from this collection? This cannot be undone.",
            replaceContributorConfirm:
                "Replace {{name}}? They will be removed from the list and you can add someone else.",
            recipientRowMenu: "Recipient actions",
            confidentialityNote: "Your answers are confidential to the collection owner.",
            contributorDraftInputDisabled:
                "This collection is still being prepared. You will be able to respond once the owner activates it.",
            loadingSession: "Loading your secure session…",
            redirectingToSignIn:
                "Opening sign-in so your {{appName}} account opens this contribution…",
            thankYouTitle: "Thank you for your contribution!",
            thankYouBody: "Your responses have been securely recorded. You can now export your transcript.",
            collectionEndedBadge: "Collection ended",
            collectionEndedModalTitle: "This collection has ended",
            collectionEndedModalBodyClosed:
                "The owner has closed this collection.",
            collectionEndedModalBodyDeadline:
                "The deadline for this collection has passed.",
            collectionEndedModalOk: "OK",
            completedPlaceholder: "Conversation completed",
            typeMessage: "Type your response here...",
            quickActions: "Quick Actions",
            exportTranscript: "Export my transcript",
            privacy: "Privacy",
            privacyText: "This conversation is private between you and the collection owner. Your individual responses are not visible to other participants.",
            privacyTextAnonymousLine1:
                "Your answers are private. The collection owner sees them under a fictitious name only",
            privacyTextAnonymousLine2:
                "and cannot link that name to you. Other participants cannot see your answers.",
            anonymousBadge: "Anonymous",
            anonymousBadgeTitle:
                "Your replies are labeled with a fictitious name for the collection owner; they cannot identify you from it.",
            anonymousSessionNote:
                "This collection is anonymous: the owner only sees a fictitious label for each participant, not who they are.",
            checklist: {
                obj: {
                    label: "Define objective",
                    detailDone: "Captured from chat",
                    detailPending: "Answer the first question"
                },
                ctx: {
                    label: "Add context",
                    detailSkipped: "Skipped",
                    mapsOne: "1 process map",
                    mapsMany: "{{count}} process maps",
                    docOne: "1 document",
                    detailJoinSeparator: " · ",
                    detailDoneGeneric: "Context saved",
                    detailPending: "Optional file or process map"
                },
                guide: {
                    label: "Review interview script",
                    detailGenerating: "Generating…",
                    detailApproved: "Approved",
                    detailReady: "Action needed",
                    detailPending: "Waiting for setup",
                    detailSetupBlocked: "Finish Collect setup before approving the script.",
                },
                rec: {
                    label: "Add recipients",
                    detailDone: "{{count}} added",
                    detailPending: "Stakeholders who will answer"
                },
                interviews: {
                    label: "Interviews completed",
                    detailProgress: "{{completed}} of {{total}} completed"
                }
            }
        },
        collectResults: {
            backToWorkspace: "Back",
            exportXlsx: "Export XLS",
            responseBadge: "{{done}} / {{total}} responses",
            tabSummary: "Dashboard",
            tabTable: "Table",
            insightsCta: "Analyse in Insights",
            statResponses: "Responses",
            statResponsesSubAll: "100% completion",
            statResponsesSubPartial: "{{pct}}% completion",
            statQuestionsCovered: "Questions covered",
            statQuestionsSub: "of {{total}} in interview script",
            statAvgLead: "Avg. lead time",
            statAvgLeadSub: "across all steps",
            statAvgLeadEmpty: "—",
            responsesCountLabel: "{{count}} responses",
            noSynthesisYet: "No responses yet. Once contributors complete the interview, you can generate an interactive dashboard here.",
            tableEmpty: "No responses to compare yet.",
            tableLoadError: "Could not load the comparison table.",
            respondentCol: "Respondent",
            guideSectionFallback: "Interview script",
            dashboardTitle: "Interactive dashboard",
            dashboardBody:
                "AI-generated charts for this collection will appear here. Use the Analysis button to open Insights for in-depth reports.",
            dashboardCreditsNotice: "Each dashboard generation will cost {{credits}} AI credits.",
            dashboardRadarHint: "Your data may support a radar chart — the AI will decide when building the dashboard.",
            dashboardGenerate: "Generate dashboard ({{credits}} credits)",
            dashboardRegenerate: "Regenerate",
            dashboardGenerating: "Generating dashboard…",
            dashboardLoading: "Loading dashboard…",
            dashboardStale: "Collection data has changed since this dashboard was generated.",
            dashboardGenerateError: "Could not generate the dashboard. Try again.",
            dashboardProviderBilling:
                "AI provider (OpenAI) has no quota or credits. Top up at platform.openai.com or contact {{appName}} support.",
            dashboardProviderAuth:
                "OpenAI API key is invalid. Check the OPENAI variable on the API server."
        }
    },

    features: {
        swimlane: {
            accessGranted: "Access granted",
            addRowUp: "Add row up",
            addRowDown: "Add row down",
            moveRowUp: "Move row up",
            moveRowDown: "Move row down",
            addDocument: "Add a document",
            approveQuestion: "Are you sure you want to approve this diagram?",
            arrowsAttributes: "Arrows attributes",
            warnings: "Warnings",
            analysis: "Analysis",
            analyzeAllAttributesData: "A complete picture of structure, roles, steps and key metrics",
            analyzeLead: "Lead time by step — where duration accumulates across the process",
            analysisName: "Analysis name",
            bottleneckIdentification: "Where is work getting stuck?",
            collaboratorAccessManagement: "Collaborator access management",
            ctrlMouseWheel: "Ctrl + MouseWheel",
            deleteRow: "Delete row",
            deleteAnalysis: "Delete analysis",
            deleteAnalysisConfirm: "Are you sure you want to delete this analysis?",
            disableEditMode: "Disable Edit Mode",
            disaableMapEdit: "Disable Map Edit",
            disaableDataEdit: "Disable Data Edit",
            disApproveQuestion: "Êtes-vous sûr de vouloir désapprouver ce diagramme ?",
            doYouwantSaveave: "Do you want to save the changes made to the diagram before leaving?",
            dontLikeReport: "I don't like this report",
            editableAttrinbutesConfiguration: "Editable Attributes Configuration",
            enableEditMode: "Edit Map",
            enableMapEdit: "Enable Map Edit",
            enableDataEdit: "Enable Data Edit",
            enterYourPrompt: "Ask anything about your process",
            enterAnalysisName: "Enter analysis name",
            exportPDF: "Export to PDF",
            exportPNG: "Export to PNG",
            exportCSV: "Export to CSV",
            exportXES: "Export to XES",
            examineDefect: "Error-prone steps, defect rates and compliance gaps",
            famlaMake: "{{appName}} may make mistakes. Verify important findings.",
            feedbackPlaceholder: "Please tell us what we can improve...",
            fontSize: 'Font size',
            giveAccess: "Give access",
            helpful: "Rate this map",
            howCanHelpYouToday: "Enter a prompt to generate a detailed analysis in just a few moments.",
            hideElements: "Hide Elements",
            hideLayers: "Hide Attributes",
            improvSentence: " We are partnering with industry leaders to support your unique improvement journey - Coming soon . ",
            identifyStakeholders: "Steps causing delays, rework loops or unnecessary handoffs",
            likeReport: "I like this report",
            leadTimeAnalysis: "Where is time being lost?",
            mapSaveWithSucess: "Map save with sucess",
            makeCopy: "Make a copy",
            copySuffix: "copy",
            copyCreated: "Copy created successfully",
            linkAttributesPrompt: "Choose attributes",
            addSheet: "Add Sheet",
            allSheets: "All Sheets",
            hiddenSheets: "Hidden Sheets",
            hideSheet: "Hide Sheet",
            showSheet: "Show Sheet",
            moveSheetLeft: "Move Left",
            moveSheetRight: "Move Right",
            renameSheetPrompt: "New sheet name",
            deleteSheetConfirm: "Delete this sheet?",
            deleteSheetConfirmDetailed: "You are about to delete \"{{name}}\". This action cannot be undone.",
            sheetCreated: "New sheet created",
            sheetRenamed: "Sheet renamed successfully",
            sheetDeleted: "Sheet deleted",
            sheetDeletedDetailed: "\"{{name}}\" was deleted successfully.",
            sheetDeleteFailed: "Failed to delete \"{{name}}\". Please try again.",
            cannotDeleteLastSheet: "Cannot delete the last sheet",
            cannotDeleteLastSheetDetailed: "You cannot delete the last sheet. Add another sheet first.",
            untitledSheet: "Untitled",
            newSheetDefaultName: "Sheet",
            sheetSwitching: "Loading sheet…",
            sheetSwitchingNamed: "Loading {{name}}…",
            mapExist: "This name is already in use for another map. Try a different name.",
            moveToBin: "Move to Bin",
            newAnalysis: "New insight",
            newDocument: "New Document",
            newInsight: "New insight",
            addProcess: "Add process",
            processes: "Processes",
            recentInsights: "Recent insights",
            noProcessesLinked: "No processes linked. Add one to get insights.",
            noAccess: "No access",
            noDocuments: "No documents yet",
            selectedDocuments: "Selected documents",
            selectMapFirst: "Please select at least one map",
            errorLoadingAnalysis: "Unable to load analysis",
            unsavedAnalysis: "Unsaved Analysis",
            unsavedAnalysisMessage: "You have an unsaved analysis in progress. Would you like to save it before creating a new analysis?",
            unsavedAnalysisLeaveMessage: "You have an unsaved analysis in progress. Would you like to save it before leaving this page?",
            unsavedDraft: "Unsaved draft",
            unsaved: "Unsaved",
            unsavedChanges: "Unsaved changes",
            cancel: "Cancel",
            discardAnalysis: "Discard",
            saveAndContinue: "Save",
            saveAnalysis: "Save Analysis",
            analysisName: "Analysis Name",
            analysisNameRequired: "Analysis name is required",
            analysisNameAlreadyExists: "You already have an analysis with this name. Please choose another name.",
            errorSavingAnalysis: "Error saving analysis",
            saveAnalysisHint: "This analysis will be accessible from \"{{section}}\" in the sidebar.",
            saving: "Saving...",
            save: "Save",
            continueWithoutSaving: "Do you want to continue without saving?",
            continueWithoutSavingLeave: "Do you want to leave without saving?",
            leaveWithoutSaving: "Leave without saving",
            saveAnalysisTip: "Use the",
            saveAnalysisTip2: "button on your reports to save them.",
            ignoreAndContinue: "Ignore and continue",
            noReportsMatchSearch: "No report was found.",
            noSavedReports: "No saved reports.",
            noInformation: "No information found for this block. The reference may not have been found",
            oops: " Oops! Something Went Wrong",
            oopsSomething: "Oops, something went wrong while saving. It might be related to the data structure. Please try again in a moment",
            openInterview: " Open Interview",
            open: "Open",
            onboardingTutorial: "Onboarding Tutorial",
            pleaseWait: "The diagram is loading. It should be ready in just a few seconds",
            processOwner: "Process Owner",
            properties: "Toolbar",
            prompt1: "Please analyze all attributes data and provide a summary of key insights for each attribute, highlighting significant patterns and trends.",
            prompt2: "Analyze stakeholder data to identify those with the highest backlog and longest action times. Use irritants and improvement data to suggest targeted performance enhancements.",
            prompt3: "Review lead time attribute data, provide detailed analysis, and suggest improvement actions based on identified irritants and potential enhancements.",
            prompt4: "Analyze defect rate attribute data, provide insights on quality trends, and recommend improvement actions based on identified issues and enhancement opportunities.",
            compareProcesses: "Compare Processes",
            compareMultipleProcesses: "Compare selected processes to identify differences.",
            promptCompareProcesses: "Compare the processes I've selected and identify their main differences and similarities.",
            identifyBottlenecks: "Identify Bottlenecks",
            findCommonBottlenecks: "Find common bottlenecks in the selected processes.",
            promptBottlenecks: "Identify common bottlenecks in the selected processes and suggest solutions.",
            analyzeEfficiency: "Analyze Efficiency",
            compareEfficiencyMetrics: "Compare efficiency metrics between processes.",
            promptEfficiency: "Compare efficiency metrics (time, costs, quality) between the selected processes.",
            bestPractices: "Best Practices",
            identifyBestPractices: "Identify best practices to share.",
            promptBestPractices: "Identify best practices in the selected processes that can be applied to others.",
            selectAtLeastOneProcess: "Please add at least one process to analyze by clicking the \"+\" button",
            qualityAnalysis: "Where are errors and rework happening?",
            removeAccess: "Remove access",
            redo: "Redo",
            reportAbug: "Report a bug",
            reportGenerate: "What do you want to learn about this process?",
            reportsDescription: "Select a process to explore its mappings.",
            scope: "Analysis scope",
            shareYourFeedback: "Share Your Feedback",
            showLayers: "Show Attributes",
            saveFileAs: "Save file as",
            saveAnalysis: "Save analysis",
            selectAll: "Select All",
            fitBlocksToContent: "Fit to content",
            resetBlocksContentFit: "Reset content fit",
            selectMap: "Add a map",
            selectDataCollection: "Add data from survey",
            collectLinkNeedsResponses:
                "This collection has no contributor responses yet. Complete at least one interview before linking it to analysis.",
            selectedForAnalysis: "Selected Items",
            shapes: "Shapes (drag & drop)",
            addTextAnnotation: "Add text annotation",
            bpmn: {
                textAnnotation: "Text annotation",
            },
            // eslint-disable-next-line no-template-curly-in-string
            s1: "As a process owner, you've saved a whopping {{time}} minutes on interviews!",
            // eslint-disable-next-line no-template-curly-in-string
            s2: "{{time}} interview minutes reclaimed! {{appName}} empowers process owners like you.",
            // eslint-disable-next-line no-template-curly-in-string
            s3: "{{time}} minutes saved on interviews. Process owners, {{appName}} streamlines your work.",
            stakeholder: 'Stakeholder',
            sucessApprov: "Success! The diagram has been successfully approved.",
            sucessDisapprov: "Success! The diagram has been successfully rejected.",
            suggestions: "Suggestions",
            summaryStatistics: "How is my process performing overall?",
            swimlaneNameIsNandatory: "swimlane name is mandatory",
            tasksAttributes: 'Tasks attributes',
            warningSingleConnection: "Single connection",
            warningsLoading: "Loading warnings…",
            warningOneSidedFlow: "One-sided flow",
            warningStakeholderMismatch: "This task has been raised by someone other than the assignee.",
            undo: "Undo ",
            uploadFile: "Upload file",
            versionHistory: "All Sheets",
            Renamesheet: "Rename Sheet",
            verifInfo: "Verify Map Info",
            verificationSourceTitle: "Source",
            verificationUnavailableTitle: "Source",
            verificationOnlyAiOrUpload:
                "This command is only available for diagrams automatically generated from AI interviews or upload documents",
            verificationNotAvailableImage:
                "This feature is not available when the map was built from an image or a file.",
            verificationHumanIntro:
                "Below are the interview passages that best match the diagram step you selected.",
            verificationDiagramStepLabel: "Diagram step",
            verificationExcerpt: "Excerpt {{n}}",
            verificationSourceText: "Source text",
            WeSorry: "We were unable to display your swimlane diagram due to a technical issue, such as network connectivity problems, server errors, or incorrect data formatting. To return to the chatbot and allow the diagram to regenerate automatically, please click 'Refresh' and wait while the process completes.",
            yourChangesWereNotSaved: "Your changes were not saved. We kindly invite you to refresh the page and try again.",
            autoSavePending: "Unsaved changes",
            autoSaveSaving: "Saving...",
            autoSaveSaved: "All changes saved",
            autoSaveError: "Error saving",
            participantsOnline: "participant(s) online",
            userJoinedMap: "joined the map",
            userLeftMap: "left the map",
            wsConnected: "Automatic saving activated",
            wsDisconnected: "Disconnected",
            online: "Online",
            readOnlyMap: "You don't have edit permissions for this map",
            mapGenTitle: "Generating your process map…",
            mapGenSubtitle: "We'll notify you when your map is ready",
            mapGenStep1: "Analyzing interview data…",
            mapGenStep2: "Drawing the flow…",
            mapGenStep3: "Finalizing the layout…",
            mapGenCountdown: "Estimated time remaining: {{mm}}:{{ss}}",

        }
    },

    navigation: {
        addAnotherEmail: "Add another email",
        allRightsReserved: "All rights reserved.",
        allFieldsRequired: "All fields marked with (*) are required.",
        anErrorOcured: "An error has occurred please try again later",
        anErrorOccurred: "An error has occurred. Please try again later.",
        anErrorOcuredProcessNotFund: "An error occurred. Process not found.",
        anErrorOccurredMappNotFound: "An error occurred. mappnot found",
        assigningProcessFolder: "Assigning a process to a folder",
        approvalCannotCreateByUser: "You cannot request approval as a collaborator.",
        backHome: "Back home",
        backToDashboard: "Back to Dashboard",
        backToFamla: "Back To {{appName}}",
        contactUs: "Contact Us",
        deleteConfirmation: "Delete Confirmation",
        diagramName: "Diagram name",
        diagramsPendingApproval: "Diagrams Pending Approval",
        enterRole: "Enter a role",
        enterFolderName: "Enter a folder name",
        enterProcessName: "Enter a process name",
        enterValideEmail: "Enter a valide e-mail",
        enterAtLeastOneEmail: "Add at least one e-mail",
        enterEmailOrPhone: "Add at least one email or WhatsApp phone number",
        whatsappPhone: "WhatsApp phone (E.164)",
        whatsappOptionalHint: "Optional: invite via WhatsApp (phone number with country code, e.g. +33...)",
        whatsappConsentLabel: "I confirm the contributor agreed to receive WhatsApp messages",
        whatsappConsentRequired: "WhatsApp consent is required when inviting by phone",
        addAnotherPhone: "Add another phone number",
        whatsappInProgress: "In progress on WhatsApp",
        whatsappSupervisionHint: "This interview runs on WhatsApp. History is read-only here.",
        phoneUpdated: "Phone number updated",
        editPhone: "Edit phone number",
        fileSize: "File size exceeds 10MB limit",
        fileAlreadySelected: "This file is already selected",
        folderSuccessfully: "Folder successfully updated.",
        folderNotFound: "Error: Folder was not found",
        interviewNotOver: "Interview not over",
        inviteOwner: "Invite teammates to join",
        inviteAApprover: "Invite a approver",
        inviteCollaborator: "Invite a contributor",
        inviteYourTeammates: "Invite your teammates",
        invitationSentSuccessfully: "Invitation sent successfully",
        logOut: 'Log out',
        loading: "Loading...",
        markAsFinal: "Mark As Final",
        mapWithNotFound: "An error occurred: Map with not found.",
        switchingCompany: "Switching company...",
        noData: "No Data",
        noMatchingResults: "No matching results",
        noRequest: "No Requests to Approve",
        privacyHub: 'Privacy Hub',
        shareLink: "Share link",
        skipThisStep: "Skip this step",
        searchAmap: "Search a map",
        selectFolder: "Select folder",
        selectRole: 'Select a role',
        sendInvitations: "Send invitations",
        sending: "Sending",
        successfullyUpdated: "Successfully updated",
        transcript: "Download transcript",
        termsOfUse: "Terms Of Use",
        theProcessHasBeenHalted: "The process has been successfully halted.",
        time_remaining: "Time remaining: {{count}} day{{count, plural, one {} other {s}}}",
        timeSaved: "Total Time saved",
        userGuide: "User guide",
        oops: "Oops! The page was not found",
        privacyPolicy: "Privacy Policy",
        process: "Process",
        processName: "Process name",
        processchange: "The process can only be modified once it has been completed.",
        processClassifiedWithSuccess: "Process classified with success",
        processCannot: "You are not authorized to update this process.",
        processNotFound: "The process could not be found.",
        proJectNotFound: "The project could not be found.",
        processSuccessfully: "Processus mis à jour avec succès.",
        publishQuestion: "Mark as final? This will make the Process read-only and prevent further editing.",
        proTip: "Pro Tip",
        proTipSmalltext: "Invite your teammates to collaborate on process mapping. Together, you'll unlock deeper insights and greater impact!",
        roleAlreadyExist: "Role already exist",
        roleNotFound: "An error occurred. role not found",
        simplyLeverage: "Or simply leverage the expertise of our consultation team.",
        sendReminder: "Send reminder ",
        termsAndConditions: "Terms and conditions",
        textProtip: "Using {{appName}} alone is like using Social Media alone - not much fun, and not much value",
        youAreNotLoggedIn: "You are not logged in",
        youAreNotAuthorized: "You are not authorized to upgrade this Folder.",
        youAreNotAuthorizedToPerformThisAction: "You are not authorized to perform this action."
    }
    ,

    layout: {
        header: {
            approvalRequests: "Approval Requests",
            upgradeToPremium: "Choose a plan - {{daysRemaing}} day left",
            upgradeToPremiums: "Choose a plan - {{daysRemaing}} days left",
            upgradeToPrem: "Choose a plan",
            updateCompany: 'View company',
            company: 'Companies',
            changeCompany: "Change company",
            selectCompany: "Selecting a company will update your session and reload the application.",
            brandAlt: "{{appName}}",
            menuToggle: "Toggle navigation",
            planUnknown: "—",
            planFREE: "Free",
            planESSENTIAL: "Essential",
            planPLUS: "Plus",
            planENTERPRISE: "Enterprise",
            langShortEN: "EN",
            langShortFR: "FR",
            shortcutMac: "⌘K",
            shortcutWin: "Ctrl+K",
            roleAdmin: "Admin",
            roleUser: "User",
            userMenuNav: "User account menu"
        }
    },

    views: {
        analysis: {
            title: "AI Process Analysis",
            subtitle: "Select a process to analyze",
            noProcesses: "No processes available",
            createFirstProcess: "Create your first process to start analyzing",
            lastUpdated: "Last updated",
            analyze: "Analyze",
            analyzing: "Analyzing"
        },
        auth: {
            accountAlreadyExist: "Account already exist",
            inviteExistingAccountUseLogin: "An account already exists with this email. Sign in to continue.",
            alreadyHaveAccount: "Already have an account ?",
            anErrorOcured: "An error has occurred please try again later",
            amazingFeatures: "You're one click away from unlocking amazing features!",
            compagnyNameIsRequired: "Compagny name is required",
            continueWithApple: "Continue with Apple",
            continueWithGoogle: "Continue with Google Workspace",
            googleSsoProOnly: "Google sign-in is only available for professional email addresses. Personal emails (Gmail, Yahoo, etc.) are not allowed. Please use a company email address or sign up with email/password.",
            continueWithMicrosoft: "Continue with Microsoft",
            continueWithST: "Continue with STMicroelectronics",
            stWelcomeMessage: "Sign in with your STMicroelectronics account to access {{appName}}",
            stSecurityMessage: "Secure connection via STMicroelectronics authentication system",
            stSsoErrorTitle: "ST SSO sign-in failed",
            stSsoErrorFallback: "Sign-in via STMicroelectronics failed. Please try again.",
            clicking: "Please verify your email by clicking the link in your inbox.",
            dontHaveAccount: "Don't have an account ?",
            enterValidMail: "Enter a valid work e-mail address",
            eliminate: "Eliminate Waste, Slash Costs and Maximise Profits with proven Lean Six Sigma methodologies.",
            emailAddres: "E-mail Address",
            emailAddresPro: "Work e-mail address",
            emailIsRequired: "E-mail is required",
            emailAddressIs: "E-mail address is incorrect or does not exist",
            establish: "Establish clear roles & responsibilities, remove ambiguity, optimize collaboration and drive team's success.",
            famlaTeam: "{{appName}} Team ",
            forgotPassword: "Forgot your password?",
            getStarted: "Get Started",
            getStartedForFree: "Get started for free",
            hi: "Hi",
            incorrectEmailOrPassword: "Invalid e-mail or password",
            captchaRequired: "Too many failed attempts. Please complete the security check below, then try again.",
            captchaInvalid: "Security check failed or expired. Please complete it again.",
            captchaMissing: "Please complete the security check before signing in.",
            logIn: "Log In",
            signInToYourAccount: "Sign In to Your Account",
            signInWithMicrosoft: "Sign in with Microsoft",
            signUpWithMicrosoft: "Sign Up with Microsoft",
            or: "OR",
            msgReset: "We will send you instructions for resetting your password upon entering your e-mail address",
            mailVerification: "Check your mailbox We've sent you a reset link.",
            newPassword: "New password",
            confirmNewPassword: "Confirm new password",
            newPassWordIsRequired: "newPassword is required",
            password: "Password",
            passwordsNotMatch: "Passwords do not match",
            passwordIsRequired: "Password is required",
            passwordSuccessfully: "Password successfully reset",
            professionalEmail: "Invalid email. Please enter a professional work email (e.g. name@yourcompany.com)",
            pleaseFollowTheInstructions: "Please follow the instructions",
            resetYourPassword: 'Reset your password',
            reset: 'Reset',
            signUp: 'Sign Up',
            ssoRedirectTitle: 'Your organisation uses single sign-on',
            ssoRedirectBody:
                '{{email}} is managed by your organisation\'s secure portal. No account is created here.',
            ssoRedirectDestination: 'Taking you to',
            ssoRedirectMailSending: 'Sending your sign-in link by email…',
            ssoRedirectMailSent: 'Sign-in link sent to {{email}}',
            ssoRedirectMailFailed: "We couldn't email the link, but you can continue right now.",
            ssoRedirectGoNow: 'Continue to the portal',
            ssoRedirectUseAnotherEmail: 'Use a different address',
            ssoRedirectCountdown_one: 'Redirecting automatically in {{count}} second',
            ssoRedirectCountdown_other: 'Redirecting automatically in {{count}} seconds',
            seamlessly: "Seamlessly document your processes and achieve ISO 9001:2015 compliance with confidence.",
            thisEmailHasBanned: "This e-mail address has been banned from {{appName}}",
            userDoesNotExist: "User does not exist",
            resetLinkInvalidOrExpired:
                "This reset link is invalid or expired. Open the link from your latest email, or request a new password reset.",
            verifyYourEmail: "Please verify your e-mail address",
            verifyYourEmailDetail: "Your account is not verified yet. Check your inbox for the link, or resend a new verification email to the address below.",
            resendVerificationLink: "Resend verification link",
            resendVerificationSuccess: "If this account exists and is not verified, a new verification link has been sent.",
            resendVerificationError: "Could not send the verification email. Please try again.",
            yourSessionHasExp: "Your session has expired or you are logged in on another device.",
            referral: "Referral code",
            signUpWithReferral: "Sign up with a referral code",
            authenticating: "Authenticating...",
            pleaseWait: "Please wait",
            brandHeadlineLead: "Your tireless",
            brandHeadlineAccent: "junior process analyst.",
            brandSubtitle: "Handles intake, interviews, and documentation so senior experts focus strictly on strategy and implementation",
            brandFeature1Title: "Interacts with your team",
            brandFeature1Desc: "Adaptive, role-tailored AI interviews across your entire org to understand how the work is done",
            brandFeature2Title: "Connects the dots & shows its work",
            brandFeature2Desc: "Automatically drafts source-backed and editable VSM, BPMN and process maps",
            brandFeature3Title: "Delivers deep analysis",
            brandFeature3Desc: "Flags bottlenecks, handoff delays, and Muda rooted in Lean Six Sigma methodology",
            brandBuiltBy: "Built by leaders from",
        },
        processView: {
            accessAdminPanel: "Access Admin Panel",
            accessFolders: "Access Folders",
            analyzeOptimize: "Analyze & Optimize",
            areYouSure: "Are you sure you want to delete this item?",
            brainstorm: "Turn business goals into actions",
            browseLibrary: "Browse Library",
            createAndOrganize: "Create a folder to organize your processes",
            comingSoon: " Coming soon",
            new: "New",
            defaultFolder: "Default folder",
            designFutureProcess: "Vibe Managing",
            discoverASISProcess: "Discover AS-IS Process",
            exploreSavedAndSharedProcesses: "Explore saved and shared processes",
            exploreUseCases: "Explore Use Cases ",
            folder: "Folder",
            folders: "Folders",
            folderNotFound: "Folder not found",
            generateDiagram: "Generate Diagram",
            getInspired: "Get inspired by popular and impactful process examples",
            harnessCollectiveIntelligence: "Harness collective intelligence",
            identifyGaps: "Identify gaps and get actionable insights",
            inviteTeammate: "Invite teammates",
            inviteTeammateDesc: "Harness collective intelligence",
            myProcess: 'My processes',
            myProcessesToolbar: 'Process list controls',
            myProcessesSortNewest: 'Sort by date (newest first)',
            myProcessesSortOldest: 'Sort by date (oldest first)',
            myProcessesSortNewestShort: 'Newest',
            myProcessesSortOldestShort: 'Oldest',
            myProcessesFilterStatus: 'Status',
            myProcessesFilterOwner: 'Owner',
            myProcessesFilterType: 'Type',
            myProcessesFilterAll: 'All',
            myProcessesOwnerOther: 'Other',
            myProcessesClearFilters: 'Clear filters',
            myProcessesViewMode: 'View mode',
            myProcessesViewGrid: 'Grid view',
            myProcessesViewList: 'List view',
            myProcessesNoFilterResults: 'No processes match these filters',
            navigateThroughOrganizedFoldersToFindStoredProcesses: "Navigate through organized folders to find stored processes",
            newProcess: 'New process',
            newfolder: "New folder",
            needInspiration: "Need inspiration ? Explore these popular use cases",
            library: "Library",
            overseeUserRoles: "Oversee user roles, settings, and access",
            popularUseCase: "Popular use cases",
            processNotFound: "Process not found",
            reportNotFound: "No report found",
            startJourneyPrompt: "Where should we start in your process journey?",
            turnTextIntoVisualProcessMapUsingAI: "Turn texts and images into process maps using AI",
            uncover: "Uncover how work really happens with AI-led interviews",
            viewAll: 'View all',
            homeStatsMapped: "Processes mapped",
            homeStatsInterviews: "Interviews run",
            homeStatsTeam: "Team members",
            homeStatsTimeSaved: "Total time saved",
            homeStatsSubMapped: "Total in your workspace",
            homeStatsSubInterviews: "Across your processes",
            homeStatsSubTeam: "Workspaces",
            homeStatsSubTime: "vs manual mapping in your company",
            homeStartSomething: "Start something",
            homeMapProcess: "Map a process",
            homeMapProcessDesc: "Interview stakeholders with AI to capture how work actually happens.",
            homeBuildDocument: "Build from a document",
            homeBuildDocumentDesc: "Turn existing text or images into a structured process diagram.",
            homeGetInsights: "Get insights",
            homeGetInsightsDesc: "Surface gaps, bottlenecks and improvement opportunities from your process.",
            homeVibeManaging: "Vibe managing",
            homeVibeManagingDesc: "Turn business goals into executable actions.",
            homeCollectData: "Collect Data",
            homeCollectDataDesc: "Run an AI-led survey to enrich a process map or gather structured information from your team",
            homeAutomate: "Automate",
            homeAutomateDesc: "Make your process executable. Generate apps, routing logic, and task handoffs from any mapped workflow.",
            homeRecentProcesses: "Recent tasks",
            homeTypeDataCollect: "Data collection",
            homeTypeProcessMap: "Process mapping",
            homeTypeManual: "Blank canvas",
            homeTypeAI: "AI interview",
            homeTypeHuman: "Text upload",
            homeTypeImage: "Image upload",
            homeDetailManual: "Drawn manually — no interview",
            homeDataCollectKind: "Structured responses",
            homeStatusNew: "New",
            homeStatusMapped: "Mapped",
            homeStatusOngoing: "Ongoing",
            homeStatusCompleted: "Completed",
            homeInterviewCount_one: "{{count}} interview",
            homeInterviewCount_other: "{{count}} interviews",
            homeGreetingMorning: "Good morning",
            homeGreetingAfternoon: "Good afternoon",
            homeGreetingEvening: "Good evening",
            homeGreetingFallback: "there",
            homeWelcomeSubtitle: "Pick up where you left off, or start something new.",
            homeStatsTimeSavedShort: "Time saved",
            homeBuildDiagram: "Build a diagram",
            homeHeroTitle: "Turn how work happens into a clear map",
            homeHeroDescription: "Interview your team or upload an existing text file or image — every path leads to the same editable diagram. Choose your method in the next step.",
            homeCreateDiagram: "Create diagram",
            homeMethodsSummary: "Interview · Upload · Text · Image",
            homeArtRequest: "Request",
            homeArtRequestDesc: "Submit your process, idea or task to start.",
            homeArtReview: "Review?",
            homeArtReviewDesc: "Your request is reviewed, commented and validated.",
            homeArtApprove: "Approve",
            homeArtApproveDesc: "Approved! Your process moves forward.",
            homeThenReady: "Then, when you're ready",
            homeCreateEyebrow: "Create a new process",
            homeCreateSubtitle: "Choose how to start, then fill in the details — all on one screen.",
            homeCreateDrawSubtitle: "Name your diagram and open a blank canvas right away.",
            homeStartingMethod: "Starting method",
            homeMethodInterview: "Interview",
            homeMethodThorough: "Thorough",
            homeMethodUpload: "Upload doc",
            homeMethodUploadTypes: "Text · image",
            homeMethodDraw: "Draw it",
            homeMethodBlankCanvas: "Blank canvas",
            homeMethodInterviewBlurb: "AI asks your team how work really happens and maps it.",
            homeMethodUploadBlurb: "Turn a text file or image into a structured diagram.",
            homeMethodUploadTextBlurb: "Upload a PDF, TXT or DOCX — Famla structures it into a process map.",
            homeMethodUploadImageBlurb: "Upload a PDF or image screenshot — Famla turns it into a swimlane diagram.",
            homeMethodDrawBlurb: "Start with an empty canvas and build your diagram freely.",
            homeOutputType: "Output type",
            homeOutputStandard: "Standard",
            homeOutputBpmn: "BPMN",
            homeOutputStandardBlurb: "Classic swimlane diagram",
            homeOutputBpmnBlurb: "Diagram with BPMN symbols.",
            homeDocumentType: "Document type",
            homeProcessName: "Process name",
            homeProcessNamePlaceholder: "e.g. Financial reporting",
            homeProcessPurpose: "Purpose of the process",
            homeProcessPurposePlaceholder: "Describe what this process achieves and who it serves",
            homeSelectIndustry: "Select industry",
            homeInterviewLanguage: "Interview language",
            homeCreateInterview: "Create interview",
            homeCreateUpload: "Create from document",
            homeCreateUploadText: "Create from text file",
            homeCreateUploadImage: "Create from image",
            homeCreateBlankDiagram: "Open blank canvas",
            homeCreateBlankDiagramError: "The blank canvas could not be created. Please try again.",
            homeCreateIndustryLoadError: "Unable to load industries. Please try again.",
            libraryRecentProcesses: "Recent tasks",
            libraryNewFolder: "New folder",
            libraryRecentInsights: "Recent insights",
            libraryNoInsights: "No insights yet",
            libraryFolderProcessCount: "{{count}} processes",
            addProcessOwner: "Add process owner",
            addCollectionOwner: "Add a collection owner",
            addCollectionOwnerHint:
                "Enter the work email of a user who already has an account and is a member of your company.",
            addCollectionOwnerScenarios:
                "Only company members are accepted. If the person is not in your company, the request is rejected.",
            addProcessOwnerHint: "Enter the work email of a user who already has an account and is a member of your company.",
            addProcessOwnerScenarios: " Only company members are accepted.If the person is not in your company, the request is rejected. If they already have a role on this process (e.g. collaborator), the request is rejected until that collaboration is removed."
        },
        processInterview: {
            addCollaborators: "Add Collaborators",
            attachFile: "Attach a file",
            skipForNow: "Skip for now",
            skipContextAnswer: "I'll skip adding documents for now.",
            contextFileAttachedNote: "I've attached a file for context: {{fileName}}.",
            contextMapsAttachedNote: "I've attached maps for context: {{mapNames}}.",
            contextChoiceAria: "Optional context: file, process map, or skip",
            browse: 'Browse',
            cannotReplaceOwner: "You cannot replace the interview owner.",
            cannotReplaceWhenInterviewFinished: "You cannot replace a participant when the interview is finished.",
            cannotDeleteMappedInterview: "Deleting this interview will regenerate the process map and consume credits.",
            collaborators: "Contributors",
            contributor: "Contributor",
            notInvited: "Not invited",
            confirmEditPermissionGrant: "Are you sure you want to allow this employee to edit the process map?",
            confirmEditPermissionRevoke: "Are you sure you want to revoke this user's edit permissions?",
            confirmDeleteAnalysisReport: "Are you sure you want to permanently delete this analysis report? This action cannot be undone.",
            comment: 'Comment',
            dropYourFileHere: "Drag and drop your file here, or",
            diagramsList: "Diagrams list",
            noDiagrams: "No diagrams yet",
            noAnalyses: "No insight yet",
            disableEditMode: "Disable Edit Mode",
            deleteDiagramme: "Are you sure you want to permanently delete this diagram? This action cannot be undone",
            diagramDeletedSuccess: "The diagram has been deleted successfully.",
            diagramDeletedError: "Failed to delete the diagram. Please try again.",
            analysisDeletedSuccess: "The analysis report has been deleted successfully.",
            analysisDeletedError: "Failed to delete the analysis report. Please try again.",
            deleteInterviewQuestion: "Are you sure you want to delete this interview? This action is irreversible.",
            deleteOwnerInterviewQuestion: "Remove the process owner’s interview? They remain the process owner; only the interview is deleted.",
            deleteMappingSourceTitle: "Delete and regenerate the process map",
            deleteMappingSourceWarning: "This person’s input was used as a source for the process map. Deleting them will trigger a new generation and consume credits (minimum {{credits}}).",
            deleteMappingSourceRoleWarning: "At least one person in this role was used as a source for the process map. Removing them will trigger a new generation and consume credits (minimum {{credits}}).",
            deleteAndRegenerate: "Delete and regenerate",
            enableEditMode: "Enable Edit Mode",
            fileUploaded: "File uploaded successfully.",
            grantEditPermission: "Granting publishing rights",
            interviewNotFound: "An error occurred. Interview not found.",
            mapReady: "Map ready in 10 minutes",
            memberAdded: "Member added successfully.",
            newProcess: "New process",
            pendingInvitation: "Pending Invitation",
            requestLimit: "Request limit reached. Upgrade to Premium to continue without interruption.",
            pasteTranscriptInstruction: "Upload a file... Add some context if needed, then press Send",
            oneActionAtTime: "Please perform only one action at a time: either paste the transcript or upload a file.",
            pleaseEnsure: "Please ensure consistent spelling of stakeholders and clients in all communications.",
            processNotFound: "An error occurred. Process not found.",
            processUpdateRestricted: "You are not authorized to modify this process.",
            recentAnalyses: 'Recent analysis',
            reminderMessage: "A reminder email will be sent to the invited collaborator.",
            reminderSent: "Reminder email sent successfully.",
            reply1: "End of the interview thanks for your contribution.",
            reply2: "End of the interview thanks for your contribution. We will reach out to the team and come back to you later",
            reply3: "I have completed the interviews, click on generate map to view the result",
            reply4: "Please can you list missing collaborator?",
            reply5: "Is there anything else you would like to add or any additional information you think would be valuable for us to consider?",
            recentProcesses: "Recent processes",
            sucessDelete: 'The interview has been successfully deleted.',
            // eslint-disable-next-line no-template-curly-in-string
            s1: "Your process map will be ready in 10 minutes! As a process owner, you've saved a whopping {{time}} minutes on interviews and drawing!",
            // eslint-disable-next-line no-template-curly-in-string
            s2: "Your process map will be ready in 10 minutes! - {{time}} interview and drawing minutes reclaimed! {{appName}} empowers process owners like you.",
            // eslint-disable-next-line no-template-curly-in-string
            s3: "Your process map will be ready in 10 minutes! - {{time}} minutes saved on interviews and drawing. Process owners, {{appName}} streamlines your work.",
            tip: "Pro Tip: To uncover true improvement potential, document what actually happens, not the ideal or desired one.",
            interviewRailNotifications: {
                insight: {
                    label: "Insight",
                    text: "Role overlap detected between Supplier and Consumer — may indicate a handoff gap.",
                },
                update: {
                    label: "Platform update",
                    text: "Analysis & Optimization is now available. Run your first gap analysis on this process.",
                },
                event: {
                    label: "Webinar",
                    text: "Lean Six Sigma & AI — April 10 at 2 p.m. Register to reserve your spot.",
                },
                ad: {
                    label: "Upgrade",
                    text: "Unlock unlimited diagram versions with the Business plan.",
                },
            },
            validFille: "Invalid file: max 10 MB.",
            validFilleAi: "Invalid file: max 5 MB.",
            validSize: "PDF,JPG,JPEG,PNG,GIF,WEBP (max.5MB)",
            yourResponse: "Upload a file... Add some context if needed, then press Send",
            responseSimple: "Response...",
            youCannotDelete: "You cannot delete this interview because it has already been completed.",
            forceGenerate: "Force Process Map Generation",
            forceGenerateTooltip: "Get an early view of your process map. Generate now and continue interviews at any time.",
            forceGenerateConfirmTitle: "Force Process Map Generation",
            forceGenerateConfirmMessage: "Are you sure you want to force the generation of the process map? Ongoing interviews will remain accessible for participants who wish to complete them.",
            forceGenerateSuccess: "Process map generation has been triggered successfully.",
            forceGenerateCooldown: "Please wait before forcing another generation.",
            forceGenerateCooldownTimer: "Available in {{minutes}}m {{seconds}}s",
            forceGenerateSidebarMapPending: "Generating map…",
            diagramsLoading: "Loading process maps…",
            forceGenerateRequestPending: "Sending request…",
            forceGenerateNotOwner: "Only the process owner, co-owner, or company admin can force the generation.",
            forceGenerateAlreadyCompleted: "All interviews are already completed. The process map is generated automatically.",

            voiceTooltipLaunch: "Launch voice mode",
            voiceButtonLaunch: "Launch Voice Mode",
            voiceConversationStart: "Launch Voice Mode",
            voiceConversationStop: "Stop voice",
            voiceConnecting: "Connecting…",
            voiceRealtimeLabel: "Speak with the AI interviewer",
            voiceRealtimeHint: 'Say "Hi" to begin your interview.',
            voiceLocksInputPlaceholder: 'To type instead, click "Stop voice".',
            voiceLoginRequired: "Sign in to use voice mode.",
            voiceClearDraftFirst: "Send or clear your text message before starting voice.",

            // Quick Actions (Interview right rail)
            quickActionsTitle: "Quick Actions",
            startNewDiscovery: "Start new discovery interview",
            openProcessLibrary: "Open Process Library",
            exportTranscript: "Export Transcript",
            share: "Share",
            notificationsTitle: "Messages and notifications",
            noNotifications: "No messages yet.",

            // Progress steps
            scopeSet: "Scope set",
            progress: "Progress",

            // Progress section translations
            stakeholdersInvited: "Stakeholders invited",
            interviewsDone: "Interviews completed",
            interviewsInProgress: "Interviews in progress",
            mapsAvailable: "Maps available",
            diagramsGenerated: "generated",
            mapsGeneratingProgress: "Generating ({{remaining}}/{{total}} remaining)…",
            mapsGenerationTimedOut: "Generation is taking longer than expected. Maps will appear when ready, or retry with Force generation.",

            // New interview button
            newInterview: "New interview",

            // Add role functionality
            addRole: "Add role",
            addContributor: "Add Contributor",
            createRole: "Add role",
            createRolePlaceholder: "New role name",
            renameRole: "Rename role",
            currentRole: "Current role",
            changeRole: "Change role",
            dragPerson: "Drag to another role",
            dropHere: "Drop here",
            dragRole: "Drag to reorder",
            deleteRoleTitle: "Delete role",
            deleteRoleConfirm: "What should happen to people assigned to “{{role}}”?",
            deleteEmptyRoleConfirm: "Delete the role “{{role}}”? No one is assigned to it anymore.",
            reassignTo: "Reassign to another role",
            reassignTargetRequired: "Please choose a target role.",
            removeAssignments: "Remove all people from this role",
            duplicateRoleName: "This role already exists.",
            roleUpdateFailed: "Could not update role.",
            moveFailed: "Could not move contributor.",
            emptyRole: "Not invited",

            // Upgrade hint
            upgradeHint: "Unlock unlimited diagram versions with the Business plan.",
            businessPlanHint: "Unlock unlimited diagram versions with the Business plan.",
        },
        modal: {
            accessDenied: {
                title: "Access Restricted",
                message: "You do not have permission to view other collaborators' responses.",
                collaboratorInfo: "You are attempting to access responses from: ",
                whyTitle: "Why this restriction?",
                reason1: "To protect the confidentiality of each participant's responses",
                reason2: "Only the Process Owner can view all responses",
                reason3: "You can only view your own responses",
                understood: "I understand"
            },
            insufficientCredits: {
                title: "Insufficient Credits",
                message: "This action requires additional credits.",
                creditsRequired: "Credits Required",
                creditsAvailable: "Credits Available",
                deficit: "Deficit",
                suggestion: "Choose a paid plan to unlock this feature:",
                choosePlan: "Choose a Plan",
                contactOwner: "Contact your company administrator at the following address to upgrade the plan and get more credits.",
                ownerEmail: "Administrator",
                contactOwnerButton: "Contact Administrator",
            },
            planSelection: {
                title: "Choose plan",
                planDetails: "Plan details",
                plan: "Plan",
                price: "Price",
                credits: "Credits",
                subscribe: "Subscribe",
                contactSales: "Contact Sales",
                stripeInfo: "Stripe integration is in progress. You will be redirected to the secure payment page.",
                stripeComingSoon: "Stripe integration in progress. Contact us to subscribe.",
                paymentReady: "You will be redirected to the secure payment page.",
                contactUs: "To subscribe to this plan, please contact us via our contact form",
                contactUsInfo: "To subscribe, you will be redirected to our contact form",
                paymentError: "Error initiating payment. Please try again.",
                essential: {
                    description: "One-time purchase. No expiration, top-up available anytime."
                },
                plus: {
                    description: "Monthly subscription. Roll-over {{percentage}}% of unused credits (max {{max}} credits)."
                },
                enterprise: {
                    description: "Custom plan with unlimited credits, dedicated support and premium SLA. Contact us for a quote.",
                    contact: "Contact us via our contact form ({{supportEmail}}) for a custom quote"
                }
            },
            creditHistory: {
                title: "Credit History",
                filter: "Filter by type",
                filterAll: "All",
                filterDeduct: "Deductions",
                filterAdd: "Additions",
                filterTopup: "Top-ups",
                filterGift: "Gifts",
                filterRefund: "Refunds",
                filterRollover: "Rollovers",
                filterAdjust: "Adjustments",
                loading: "Loading...",
                noTransactions: "No transactions found",
                credits: "credits",
                pageInfo: "Page {{current}} of {{total}}",
                table: {
                    date: "Date",
                    type: "Type",
                    amount: "Amount",
                    balance: "Balance"
                },
                type: {
                    deduct: "Deduction",
                    add: "Addition",
                    topup: "Top-up",
                    gift: "Gift",
                    refund: "Refund",
                    rollover: "Credit rollover",
                    adjust: "Adjustment"
                },
                action: {
                    generation: "Process generation",
                    analysis: "Process analysis",
                    mappingUnlock: "Mapping unlock"
                }
            },
            subscription: {
                title: "Manage My Subscription",
                loading: "Loading details...",
                details: "Subscription Details",
                statusLabel: "Status",
                monthlyAmount: "Monthly Amount",
                nextBillingDate: "Next Billing",
                cancelScheduledLabel: "Scheduled Cancellation",
                endOfPeriod: "End of Period",
                cancelScheduled: "Scheduled Cancellation",
                cancelScheduledDescription: "Your subscription will be canceled on",
                keepAccess: "You will keep access to PLUS features until this date.",
                reactivate: "Reactivate",
                processing: "Processing...",
                cancelButton: "Cancel Subscription",
                openPortal: "Manage via Stripe Portal",
                opening: "Opening...",
                confirmCancel: "Confirm Cancellation",
                confirmCancelDescription: "Are you sure you want to cancel your PLUS subscription?",
                cancelImmediately: "Cancel Immediately",
                cancelAtPeriodEnd: "Cancel at Period End",
                immediateInfo: "Immediate cancellation will reset your credits to 0 and you will lose access to PLUS features.",
                gracefulInfo: "Canceling at period end allows you to continue using your credits and PLUS features until the end of the billing cycle.",
                confirm: "Confirm Cancellation",
                cancel: "Cancel",
                cancelSuccess: "Your subscription has been successfully canceled",
                reactivateSuccess: "Your subscription has been successfully reactivated",
                error: "An error occurred. Please try again or contact support."
            },
            paymentMethods: {
                title: "Payment Methods",
                loading: "Loading payment methods...",
                empty: "No payment methods registered",
                default: "Default",
                expires: "Expires",
                info: "Manage your payment methods via the Stripe portal to add, edit, or remove a card.",
                openPortal: "Open Stripe Portal",
                emptyDescription: "Add a payment method via the Stripe portal to manage your payments."
            },
            invoices: {
                title: "My Invoices",
                loading: "Loading invoices...",
                noInvoices: "No invoices found",
                empty: "No invoices available",
                emptyDescription: "Your invoices will appear here after your first payments.",
                date: "Date",
                amount: "Amount",
                status: "Status",
                download: "Download PDF",
                statusPaid: "Paid",
                statusOpen: "Pending",
                statusDraft: "Draft",
                statusVoid: "Canceled",
                statusUncollectible: "Uncollectible"
            },
            planChange: {
                title: "Change Plan",
                loading: "Loading available plans...",
                currentPlan: "Current Plan",
                recommendation: "Recommendations",
                availablePlans: "Available Plans",
                downgradeWarning: "Warning - 2-step process",
                plusToEssentialSteps: "To switch from PLUS to ESSENTIAL, you must first cancel your PLUS subscription, then activate ESSENTIAL.",
                upgradeInfo: "You will be redirected to secure payment. The change will be effective immediately after payment.",
                error: "Error loading available plans",
                processing: "Processing...",
                confirm: "Confirm Change"
            },
            topUp: {
                title: "Top Up Credits",
                currentBalance: "Current Balance",
                credits: "Available Credits",
                packageDetails: "Top-up Package Details",
                package: "Credits Package",
                price: "Price",
                newTotal: "New Total Balance",
                howItWorks: "How it works?",
                info1: "Credits are added immediately to your balance",
                info2: "No expiration, use them whenever you want",
                info3: "You stay on your current ESSENTIAL plan",
                info4: "Secure payment via Stripe",
                info4Microsoft: "Purchase and billing via Azure Marketplace (Microsoft account)",
                benefits: "With these credits, you'll be able to",
                benefit1: "new processes to generate",
                benefit2: "document analysis tokens",
                benefit3: "Access to all ESSENTIAL features",
                purchase: "Purchase for",
                purchaseViaAzure: "Buy via Azure Marketplace"
            }
        },

        processByGroupView: {
            approvalName: 'Approver name',
            approvalDate: 'Approval date',
            dateFormat: "Date format must be YYYY-MM-DD HH:MM:SS",
            diagramLink: "Diagram link",
            formatDate: "YYYY-MM-dd HH:mm:ss",
            interviewTime: "Interview Time saved",
            lastModifiedDate: "Last modified date",
            noProcess: "No process",
            nexRevisionDate: "Next revision date",
            ownerName: "Owner's name",
            processName: "Process name",
            processMetrics: "Process Metrics",
            revisionTriggers: "Revision Triggers",
            requestChange: "Request change",
            industryLabel: "Industry"
        },

        legalDocs: {
            contact: {
                eitherFill: "You can fill in the form or use the contact details below.",
                gettingInTouch: "Getting in touch is easy!",
                sendMeCopy: "Send me a copy",
                success: "Message sent successfully!",
                error: "An error occurred while sending the message. Please try again.",
                invalidEmail: "Please enter a valid email address.",
            },

            faq: {
                contactUsPage: 'contact Us page',
                p1: "Think of your processes as your organization's DNA – they're the blueprint for how things get done! {{appName}} was created to help organizations of all sizes, industries, and locations understand, document, and streamline those essential workflows. So, what makes {{appName}} the perfect fit for you? It's all about simplicity, speed, and a powerful AI improvement engine that helps you work smarter, not harder",
                p2: "This initial version focuses on cross-functional swimlane diagrams. These are perfect for visualizing how work flows across different teams or departments. We'll be adding more diagram types soon!",
                p3: "Yes! We support common notations like BPMN (Business Process Model and Notation) to ensure consistency and easy understanding.",
                p4: "Of course. Export your process maps as images (PNG, JPEG) or PDFs – perfect for reports, presentations, or getting feedback. You can also invite people to view the finished maps directly inside the tool for quick collaboration.",
                p5: "Absolutely! We built this tool with teamwork in mind. Easily invite team members to collaborate on maps in real-time, making process improvement a shared effort.",
                p6: " Not yet, but it's coming soon! We know how important it is to keep everything organized, so we're working on the ability to attach files, links, notes, and more directly within your maps.",
                p7: "Get ready for some process magic! Our AI engine analyzes your maps using Lean Six Sigma principles to pinpoint areas where you can streamline and improve.",
                p8: "Definitely. We take data security seriously. Our platform is hosted on Google Cloud, giving you top-notch security with encryption and all the latest safeguards.",
                p9: "After signing up, one of our team members will reach out to chat about your needs and the best subscription fit. In the meantime, dive right in, explore the tool and experience {{appName}}'s power firsthand!",
                p10: "Our friendly support team is here for you! Reach out anytime through our ",
                p11: "We're constantly working to improve {{appName}}!  Let us know what features you'd love to see next.",
                t1: "Is {{appName}} the perfect match for my business? ",
                t2: "What kind of process maps can I build with this tool?",
                t3: "Does this tool work with the process mapping standards I already know?",
                t4: "Can I easily share my finished maps with others?",
                t5: "Can my team and I work on a process map together?   ",
                t6: "Can I connect other information to my process maps?",
                t7: "How can this tool help me improve my processes? ",
                t8: "Is my process map data secure?",
                t9: "Do you offer a free subscription or a trial period?",
                t10: "How can I get help if I need it? ",
            },

            privacyPolicy: {
                title: "Privacy Policy",
                subtitle: "We're committed to protecting your privacy. This policy explains how we collect, use, and safeguard your information.",

                introduction: {
                    title: "Introduction",
                    p1: "{{appName}} (\"we,\" \"us,\" \"our,\" or \"Company\") operates the {{appName}} platform. This Privacy Policy explains how we collect, use, and protect your information.",
                    p2: "This Policy should be read together with our Cookies Policy and Terms of Service.",
                    p3: "By accessing and using {{appName}}, you acknowledge that you have read, understood, and agree to be bound by all the terms of this Privacy Policy. If you do not agree with our policies and practices, please do not use our services."
                },

                informationWeCollect: {
                    title: "Information We Collect",

                    personalInfo: {
                        title: "Personal Information You Provide",
                        description: "We collect information you directly provide to us, including:",
                        item1: "Account registration details (name, email, organization)",
                        item2: "Payment information for billing purposes",
                        item3: "User-generated content and process data",
                        item4: "Feedback, inquiries, and support requests"
                    },

                    automaticInfo: {
                        title: "Automatically Collected Information",
                        description: "When you use {{appName}}, we automatically collect:",
                        item1: "IP address and browser/device information",
                        item2: "Usage statistics and interaction patterns",
                        item3: "Cookies and similar tracking technologies",
                        item4: "Log files, timestamps, and authentication events"
                    },

                    thirdPartyInfo: {
                        title: "Information from Third Parties",
                        description: "We may receive information via:",
                        item1: "SSO identity providers",
                        item2: "Integration partners",
                        item3: "publicly available sources"
                    }
                },

                howWeUseYourInfo: {
                    title: "How We Use Your Information",
                    description: "We use collected information to:",
                    item1: "Provide, maintain, and improve our services",
                    item2: "Personalize your experience and deliver customized content",
                    item3: "Process transactions and send billing information",
                    item4: "Communicate with you about updates, changes, and support",
                    item5: "Conduct analytics and research to optimize our platform",
                    item6: "Detect and prevent fraud, abuse, and security incidents",
                    item7: "Comply with legal obligations and enforce our agreements"
                },

                dataSecurity: {
                    title: "Data Security",
                    description: "We implement comprehensive security measures to protect your information:",
                    item1: "End-to-end encryption in transit and at rest",
                    item2: "Customer-managed encryption keys available for dedicated setups",
                    item3: "Regular security audits and penetration testing",
                    item4: "SOC 2–aligned security program",
                    item5: "Restricted access controls and role-based permissions",
                    item6: "Secure cloud infrastructure with redundancy and backups"
                },

                yourRights: {
                    title: "Your Rights and Choices",
                    description: "You have the following rights regarding your personal information:",
                    item1: "Access your personal data and request a copy",
                    item2: "Correct inaccurate or incomplete information",
                    item3: "Delete your account and associated data",
                    item4: "Opt out of marketing communications",
                    item5: "Request data portability in a structured format",
                    item6: "Withdraw consent at any time"
                },

                dataRetention: {
                    title: "Data Retention",
                    description: "We retain your personal information for as long as necessary to provide our services and fulfill the purposes outlined in this policy. You can request deletion of your data at any time, subject to legal retention requirements. Certain information may be retained in anonymized form for analytics and compliance purposes."
                },

                intellectualProperty: {
                    title: "Intellectual Property Protection",
                    description: "All data inputs and outputs provided through {{appName}} remain exclusively yours. Your intellectual property is never used to train any large language model or shared with third parties for AI training purposes. We maintain strict policies ensuring your proprietary information and competitive advantages remain confidential."
                },

                thirdPartyServices: {
                    title: "Third-Party Services",
                    p1: "We may use third parties for hosting, analytics, authentication, and similar functions.",
                    p2: "They may only access data required to perform their role and are bound by confidentiality and security obligations."
                },

                cookiesAndTracking: {
                    title: "Cookies and Tracking",
                    p1: "{{appName}} uses cookies and similar technologies for authentication, performance, analytics, personalization, and security.",
                    p2: "For full details, please refer to our Cookies Policy."
                },

                contact: {
                    description: "If you have questions about this Privacy Policy or wish to exercise your rights, please contact us at:",
                    teamName: "{{appName}} Privacy Team",
                    email: "Email: {{supportEmail}}",
                    address: "Address: 77 Lower Camden Street, D02 XE80, Dublin, Ireland"
                },

                lastUpdated: "Last updated: November 2025"
            },
            termsOfService: {
                title: "Terms of Service",
                subtitle: "Please read these terms carefully before using {{appName}} services.",

                introduction: {
                    title: "Terms of Service",
                    p1: "Welcome to {{appName}} (\"{{appName}},\" \"we,\" \"us,\" or \"our\"). These Terms of Service (\"Terms\") govern your access to and use of {{appName}}, including our website, software, and any related services (collectively, the \"Service\"). By using the Service, you agree to be bound by these Terms.",
                    p2: "Your use of the Service is also governed by our Privacy & Security Policy and Cookies Policy.",
                    p3: "If you do not agree to these Terms, please do not use the Service. We reserve the right to modify these Terms at any time. Your continued use of {{appName}} following such modifications constitutes your acceptance of the updated Terms."
                },

                accountRegistration: {
                    title: "Account Registration",
                    p1: "You must register for an account and provide accurate information. You are responsible for maintaining the confidentiality of your account credentials and for all activities under your account.",
                    p2: "You agree to notify us immediately of any unauthorized use."
                },

                licenseGrant: {
                    title: "License Grant",
                    description: "Subject to your compliance with these Terms, {{appName}} grants you a limited, non-transferable, non-exclusive license to access and use the Service for your internal business purposes. You agree not to:",
                    item1: "Modify, copy, or create derivative works of our services",
                    item2: "Reverse engineer, decompile, or attempt to extract source code",
                    item3: "Remove or alter copyright notices or proprietary markings",
                    item4: "Rent, lease, or resell access to {{appName}}",
                    item5: "Use the service for competitive analysis or benchmarking",
                    item6: "Transmit viruses, malware, or harmful code",
                    item7: "Upload unlawful or abusive content"
                },

                userResponsibilities: {
                    title: "User Responsibilities",
                    description: "As a {{appName}} user, you are responsible for:",
                    item1: "Maintaining your account security",
                    item2: "Complying with applicable laws",
                    item3: "Not violating third-party IP rights",
                    item4: "Not engaging in illegal, threatening, or harmful behavior",
                    item5: "Notifying us immediately of any unauthorized access"
                },

                acceptableUse: {
                    title: "Acceptable Use Policy",
                    description: "You agree not to use {{appName}} for:",
                    item1: "Illegal activities or violation of any applicable laws",
                    item2: "Harassment, discrimination, or defamation",
                    item3: "Unauthorized access to systems or data",
                    item4: "Distribution of malware or harmful code",
                    item5: "Spamming or phishing activities",
                    item6: "Infringing on intellectual property rights"
                },

                intellectualProperty: {
                    title: "Intellectual Property Rights",
                    ourIP: {
                        title: "Our Intellectual Property",
                        description: "All content, functionality, and design of {{appName}} are owned by {{appName}} or our licensors. This includes text, graphics, logos, code, and software. Unauthorized reproduction or use is prohibited."
                    },
                    yourContent: {
                        title: "Your Content",
                        description: "All data inputs and outputs you provide through {{appName}} remain exclusively yours. You retain all rights to your proprietary information. We do not use your content to train AI models or for any purpose beyond providing the service you've requested."
                    }
                },

                publicityRights: {
                    title: "Publicity Rights",
                    p1: "Unless you notify us in writing that you do not grant permission, you grant {{appName}} a limited right to use your organization's name and logo (\"Customer Marks\") to identify you as a {{appName}} customer on our website, presentations, proposals, pitch decks, and similar materials.",
                    p2: "{{appName}} will not disclose confidential information and will use Customer Marks solely for identification purposes.",
                    p3: "You may revoke this permission at any time by notifying us in writing."
                },

                disclaimers: {
                    title: "Disclaimers",
                    p1: "{{appName}} is provided on an \"as-is\" and \"as-available\" basis.",
                    p2: "{{appName}} does not guarantee uninterrupted operation, error-free performance, or fitness for any particular purpose."
                },

                limitationOfLiability: {
                    title: "Limitation of Liability",
                    p1: "To the fullest extent permitted by law, {{appName}} shall not be liable for any indirect, incidental, special, or consequential damages arising from your use of or inability to use our services, including but not limited to loss of profits, data, or business interruption, even if we've been advised of such damages.",
                    p2: "Our total liability to you shall not exceed the fees you've paid to us in the twelve months preceding the claim."
                },

                indemnification: {
                    title: "Indemnification",
                    description: "You agree to indemnify, defend, and hold harmless {{appName}} and our officers, directors, employees, and agents from any claims, damages, or expenses (including legal fees) arising from your violation of these Terms, your use of {{appName}}, or your breach of any applicable law."
                },

                termination: {
                    title: "Termination",
                    description: "We may terminate or suspend your account and access to {{appName}} immediately and without notice for:",
                    item1: "Violation of these Terms",
                    item2: "Illegal activity or misuse of the service",
                    item3: "Non-payment of applicable fees",
                    item4: "Breach of our Acceptable Use Policy",
                    userTermination: "You may terminate your account at any time by contacting our support team."
                },

                governingLaw: {
                    title: "Governing Law",
                    description: "These Terms are governed by and construed in accordance with the laws of The Republic of Ireland, without regard to its conflict of law provisions. Any legal action or proceeding arising from these Terms shall be exclusively brought in the courts located in The Republic of Ireland."
                },

                contact: {
                    title: "Contact Information",
                    description: "For questions regarding these Terms of Service, please contact us:",
                    teamName: "{{appName}} Legal Team",
                    email: "Email: {{supportEmail}}",
                    address: "Address: 77 Lower Camden Street, D02 XE80, Dublin, Ireland"
                },

                lastUpdated: "Last updated: November 2025"
            },



        },
        adminOnboarding: {
            userFallback: "there",
            progress: "Step {{step}} of 2",
            skip: "Skip for now",
            welcomeTitle: "Welcome to Famla, {{name}}",
            welcomeDescription: "Famla helps you get clarity on how work gets done: whether you map a process, collect the data behind it, or run a smart survey. Pick your main goal and we'll set up your workspace around what matters to you first.",
            setup: "Let's set up",
            duration: "Takes about 30 seconds",
            goalTitle: "What do you want to do first?",
            goalSubtitle: "Pick your main goal — you can do everything else later.",
            new: "NEW",
            recommended: "RECOMMENDED",
            continue: "Continue",
            readyDescription: "Your workspace is set up for this goal. Here's exactly where we'll take you next.",
            yourGoal: "Your goal",
            goals: {
                draw: {
                    title: "Draw a diagram",
                    description: "Start from a blank canvas and drag, drop and connect shapes yourself.",
                    readyTitle: "Your blank canvas is ready",
                    readyHead: "We'll open a blank drawing canvas",
                    readyDescription: "Enter a title and we'll open a blank canvas immediately.",
                    cta: "Open the canvas"
                },
                map: {
                    title: "Map a process",
                    description: "Let AI interview your team, or turn existing text into a structured diagram.",
                    readyTitle: "Let's map your first process",
                    readyHead: "We'll open the Create a diagram screen",
                    readyDescription: "Choose an AI interview or turn existing text or an image into a structured diagram.",
                    cta: "Create a diagram"
                },
                survey: {
                    title: "Start a smart survey",
                    description: "Run an AI-led survey to gather structured input from your team.",
                    readyTitle: "Let's set up your survey",
                    readyHead: "We'll open the Create a survey screen",
                    readyDescription: "Design an AI-led survey that gathers structured input and complements your process maps.",
                    cta: "Create a survey"
                }
            }
        },
        referral: {
            title: "How did you hear about us?",
            optional: "Optional (but recommended)",
            friend: "Referral from a friend or colleague",
            internet: "Internet (newsletter, blog, podcast, etc.)",
            search: "Search engine (Google, Bing, etc.)",
            twitter: "Twitter",
            youtube: "YouTube",
            linkedin: "LinkedIn",
            other: "Other",
            back: "Back",
            continue: "Continue"
        },
        pricing: {
            title: "Plans and Pricing",
            subtitle: "Choose the plan that fits your needs",
            footer: "All plans include dedicated customer support. Contact us for more information.",
            error: "Error loading configuration. Please try again.",
            activateSuccess: "Plan processed successfully!",
            activateError: "Error activating plan: {{message}}",
            activateErrorGeneric: "Error activating plan. Please try again.",
            note: "Each credit corresponds to one process step mapped",
            units: {
                currency: "USD",
                currencyPerMonth: "USD/month",
                credits: "credits",
                creditsPerMonth: "credits/month",
                custom: "Custom",
                unlimited: "Custom",
                oneTime: "one-time",
                month: "month"
            },
            plans: {
                popular: "Popular",
                free: {
                    name: "Free",
                    description: "No expiration, perfect for exploring",
                    feature1: "{{credits}} credits, no expiration",
                    feature2: "Email support",
                    feature3: "Up to 15 users",
                    button: "Free Plan"
                },
                essential: {
                    name: "Essential",
                    description: "One-off purchase for occasional usage",
                    feature1: "{{credits}} credits, no expiration",
                    feature2: "Top up credits at will",
                    feature3: "Unlimited users",
                    feature4: "Priority email support",
                    button: "Choose Essential"
                },
                plus: {
                    name: "Plus",
                    description: "Perfect for teams driving better business performance",
                    feature1: "{{credits}} credits per month",
                    feature2: "Monthly renewal",
                    feature3: "Unlimited users",
                    feature4: "SSO and API integration",
                    feature5: "Dedicated success manager",
                    button: "Choose Plus"
                },
                enterprise: {
                    name: "Enterprise",
                    description: "For large organizations",
                    feature1: "Custom credits volume",
                    feature2: "Unlimited users",
                    feature3: "24/7 phone & email support",
                    feature4: "Enterprise analytics",
                    feature5: "Custom integrations",
                    feature6: "Dedicated success team",
                    feature7: "SLA guarantees",
                    button: "Contact Sales"
                }
            },
            microsoft: {
                title: "Azure Marketplace",
                recommended: "Recommended",
                shortMessage: "Simplified billing through your existing Azure account",
                cta: "Buy via Azure Marketplace"
            }
        },
        payment: {
            cancel: {
                title: "Payment Canceled",
                description: "No amount has been charged. You can resume your purchase at any time.",
                help: "Need help? Our team is here to assist you in choosing your plan.",
                retryPayment: "Resume Purchase",
                gotoDashboard: "Back to Dashboard",
                contactSupport: "Contact Support",
                freeAlternative: "You can continue using {{appName}} for free with the FREE plan and its 40 credits."
            },
            success: {
                title: "Payment Successful",
                description: "Your payment has been processed successfully.",
                loading: "Updating your balance...",
                newBalance: "💰 New Credit Balance",
                plan: "Plan",
                creditsAvailable: "Available Credits",
                nextBilling: "Next Billing",
                plusInfo: "Your Plus subscription renews automatically every month. You can manage it from your dashboard.",
                topupInfo: "Your top-up credits have been added to your existing balance.",
                gotoDashboard: "Go to Dashboard",
                createProcess: "Create New Process",
                security: "Payment secured by Stripe - No card data is stored on our servers",
                planDescriptions: {
                    essential: "Essential Plan activated successfully!",
                    plus: "Plus Subscription activated successfully!",
                    topupEssential: "Essential Top-up successful!",
                    default: "Payment processed successfully!"
                }
            }
        }
    },

    campaigns: {
        confirmDelete: "Are you sure you want to delete this campaign? This action cannot be undone.",
        updateError: "Failed to update campaign",
        updateCampaign: "Update Campaign",
        update: "Update",
        delete: "Delete",
        analysisCompleted: "The analysis is completed. You can now invite collaborators to help you achieve your objective.",
        updateProcesses: "Update Processes",
        editProcesses: "Edit Processes",
        view_aiAssistant: "Open AI Assistant",
        view_processes: "Manage Processes",
        view_collaborators: "Manage Collaborators",
        needToSelectACampaign: "Please select a campaign",
        createProcessesAnalysis: "End conversation and create Processes Analysis",
        comingSoon: "Coming soon",
        noMessages: "noMessages yet. Start the conversation!",
        search: "Search campaign...",
        processes: "Processes",
        noCampaigns: "No campaigns yet",
        noResults: "No results found",
        namePlaceholder: "Enter the campaign name...",
        nameRequired: "Name is required",
        name: "Name",
        createNewCampaign: "Create New Campaign",
        industry: "Industry",
        selectIndustry: "Select an industry",
        createCampaign: "Create Campaign",
        creating: "Creating...",
        close: "Close",
        description: "Description",
        descriptionPlaceholder: "Enter a detailed description of the campaign...",
        selectCampaign: "Select or create a campaign to display the AI assistant",
        typeMessage: "Type your message here",

        todoList: "Campaign Progress",
        inProgress: "In Progress",
        todoDefinitionObjectives: "Define objectives",
        todoInviteCollaborator: "Invite collaborator",
        todoInterviewsInProgress: "Collaborator interviews in progress",
        todoInterviewsCompleted: "Interviews completed",
        todoMappingsInProgress: "Mappings being finalized",
        todoReportAvailable: "Report available",
        quickActions: "Quick Actions",
        aiAssistant: "AI Assistant",
        collaborators: "Collaborators",
        report: "Report",
        processes: "Processes",
        newCampaign: "New campaign",
        recentCampaigns: "Recent campaigns",
        noReportsAvailable: "No reports available",
        suggestedProcesses: "Processes suggested by AI",
        confirmOrModifyProcesses: "You can confirm or modify this list in the chat",
        defineObjective: "Define your objective or campaign",
        objectivePlaceholder: "Ex: Improve recruitment process, Optimize order management...",
        objectiveAnalyzed: "I've analyzed your objective. Here are the processes I suggest to achieve it:",
        welcomeMessage: "Hello! I'm your AI assistant for campaign management. Let's start by defining your objective."
    },

    words: {
        danger: "Warning!",
        add: "Add",
        analysis: "Analysis",
        administrator: "Administrator",
        address: "Address",
        alignment: "Alignment",
        answer: "Answer",
        approve: "Approve",
        attributes: "Attributes",
        back: "Back",
        bold: "Bold",
        bottom: "Bottom",
        cancel: "Cancel",
        capitalize: "Capitalize",
        city: "City",
        close: "Close",
        comments: "Comment",
        confirm: "Confirm",
        copied: "Copied",
        center: "Center",
        country: "Country",
        create: "Create",
        copy: "Copy",
        done: "Done",
        revoke: "Revoke",
        decision: "Decision",
        delete: "Delete",
        demote: "Demote",
        description: "Description",
        disApprove: "Reject",
        edit: "Edit",
        edition: "Edit",
        email: "E-mail",
        english: "English",
        end: "End",
        export: "Export",
        error: "Error",
        faq: "FAQ",
        file: "File",
        filter: "Filter",
        finish: "Finish",
        french: "French",
        from: "De",
        grant: "Grant",
        help: "Help",
        home: "Home",
        hello: "Hello",
        hide: "hide",
        information: "Information",
        improve: "Improve",
        invite: "Invite",
        inviteAApprover: "Invite a approver",
        interview: "Interview",
        italic: "Italic",
        languages: "Languages",
        left: "Left",
        link: "Link",
        light: "Light",
        line: "Line",
        lowercase: "Lowercase",
        loading: "Loading",
        menu: "Menu",
        map: "Map",
        maps: "Maps",
        me: "Me",
        message: "Describe your request here",
        name: "First Name and Last Name",
        nameFolder: "Name",
        new: "New",
        no: "No",
        normal: "Normal",
        objectifProcess: "Purpose of the process",
        or: "OR",
        organize: "Move Folder",
        owner: "Owner",
        past: "Paste",
        processing: "Processing",
        promote: "Promote",
        process: "Processes",
        proces: "Task",
        publish: "Publish",
        question: "Question",
        refresh: "Refresh",
        rename: "Rename",
        remove: "Remove",
        reminder: 'Reminder',
        requestApproval: "Request approval",
        replace: "Replace",
        right: "Right",
        role: "Role",
        status: "Status",
        start: "Start",
        note: "Note",
        linkedTo: "Linked to",
        linkTask: "Link to task",
        unlinkTask: "Unlink task",
        linkTaskFirst: "Link a task first",
        linkAttribute: "Link to attribute",
        unlinkAttribute: "Unlink attribute",
        linkedAttributes: "Linked attributes",
        none: "None",
        save: "Save",
        saveAs: "Save As",
        you: "you",
        search: "Search",
        searching: "Searching",
        noResults: "No results",
        selected: "Selected",
        selecteds: "Selected",
        send: "Send",
        share: "Share",
        subject: "Subject",
        text: "Text",
        to: "To",
        top: "Top",
        token: "Token",
        uppercase: "Uppercase",
        view: "View",
        viewMore: "View more",
        showLess: "Show less",
        thank: "Thank",
        yes: "Yes",
        save: "Save",
        saving: "Saving...",
        cancel: "Cancel",
        delete: "Delete",
        rename: "Rename",
        share: "Share",
        back: "Back",
        tip: "Tip",
        characters: "characters",
        search: "Search",
        shareLink: "Share link",
        titleRequired: "Title is required",
        descriptionRequired: "Description is required",
        settings: "Settings",
        rename: "Rename",
        delete: "Delete",
        diagram: "Diagram",
        diagrams: "Diagrams",
        insight: "Insight",
        insights: "Insights",
        generate: "Generate",
        generated: "Generated",
        generateNew: "Generate new",
        getNewInsight: "Get new insight",
        runNewAnalysis: "Run new analysis",
        analyze: "Analyze",
        addRole: "Add role",
        newInterview: "New interview",
        quickActions: "Quick actions",
        progress: "Progress",
        scopeSet: "Scope set",
        of: "of",
        completed: "completed",
        library: "Library",
        interviews: "Interviews",
        businessPlanHint: "Unlock unlimited diagram versions with the Business plan."
    },


    layer: {
        connectYourProcessMaps: "Connect your process maps",
        hiddenProperties: "Hidden Properties",
        noHiddenpropertiesAvailable: "No hidden properties available",
        layerSettings: "Attribute settings",
        selectProcess: "Select a process",
        selectMap: "Select a map",
        searchProcesses: "Search processes",
        block: {
            leadtime: "Lead time",
            defectrate: "Defect rate",
            itsystem: "IT System",
            cost: "Cost",
            carbonfootprint: "Carbon footprint",
            headcount: "Headcount",
            irritantsandimprovements: "Pain Points",
            risksandcontrols: "Risks and controls",
            relateddocuments: "Related documents",
            failuremode: "Failure mode",
            link: "Link",
            wbs: "WBS",
        },
        line: {
            inventory: "Inventory",
            transfertime: "Transfer time",
            input: "Input",
            output: "Output",
            link: "Link",

        },
        enterUrl: "Enter a valid URL",
        timeUnit: "Unit",
        timeUnits: {
            min: "min",
            h: "h",
            d: "d",
            s: "s",
        },
    },

    // Professional messages for CompanyAnalysis
    companyAnalysis: {
        // Success messages
        analysisSaved: "Analysis saved successfully",
        analysisLoaded: "Analysis loaded successfully",
        draftRestored: "Draft restored successfully",

        // Professional error messages
        errorSaving: "Error saving analysis",
        errorLoading: "Unable to load analysis",
        errorSubmitting: "Error submitting prompt",
        errorNoDocuments: "Please select at least one document before starting the analysis",
        errorNoMapOrCollection: "Please select at least one map or data collection",
        errorEmptyPrompt: "Please enter a question or instruction",
        errorNoAnalysis: "No analysis to save",
        errorSession: "Session expired. Please log in again",
        insightsLinkedCollectionInaccessible:
            "This map is linked to a collection ({{names}}) you cannot access. The analysis will use the map only.",

        // Information messages
        unsavedDraft: "Unsaved draft",
        analysisInProgress: "Analysis in progress...",
        selectDocuments: "Select at least one document to start",

        // Confirmations
        confirmNewAnalysis: "You have an unsaved draft. Do you want to save it before starting a new analysis?",
        confirmDiscard: "Are you sure you want to discard your draft?",

        // Workflow
        step1: "Document selection",
        step2: "Analysis in progress",
        step3: "Saving analysis",
        step4: "Viewing results",

        heroSubtitle: "Choose a starting point or describe what you're looking for.",

        // Right panel — checklist and hints
        checklistAddDocument: "Add a process",
        checklistAskQuestion: "Ask a question",
        checklistSave: "Save the analysis",
        rightPanelHintEmpty: "Select a process and ask a question to generate an insight.",
        rightPanelHintResults: "Your results are ready. Ask a follow-up question or save the analysis.",

        // Before you start — right panel steps
        beforeYouStart: "Before you start",
        step1Title: "Select your process(es)",
        step1Desc: "Choose one or more processes to analyse.",
        step2Title: "Upload supporting documents (optional)",
        step2Desc: "Add relevant files for more context.",
        step3Title: "Prepare your map",
        step3Desc: "Verify, adjust, and enrich your map with attributes for better results.",
        step4Title: "Type your prompt",
        step4Desc: "Describe what you want to analyse or generate.",
        step5Title: "Review and act",
        step5Desc: "Explore your results and take action.",
        espaceAnnonces: "Espace Annonces"
    },

    // Tutorial system
    tutorial: {
        startTutorial: "Start Tutorial",
        buttons: {
            back: "Back",
            close: "Close",
            finish: "Finish",
            next: "Next",
            open: "Open",
            skip: "Skip",
            last: "Finish"
        },
        labels: {
            buttonNext: "Next",
            buttonBack: "Back",
            buttonSkip: "Skip",
            close: "Close",
            last: "Finish",
            open: "Open",
            skip: "Skip"
        },
        aria: {
            close: "Close tutorial",
            skip: "Skip this step",
            next: "Next step",
            back: "Previous step",
            last: "Finish tutorial"
        },
        joyride: {
            close: "Close",
            last: "Finish",
            next: "Next",
            open: "Open",
            skip: "Skip",
            back: "Back"
        },
        stepCounter: {
            step: "Step",
            of: "of",
            stepXofY: "Step {{step}} of {{total}}"
        },
        home: {
            pageName: "Home",
            welcome: "Welcome to {{appName}}! This platform helps you turn goals into action, rooted in your reality. Let's explore the main features for operational excellence.",
            welcomeTitle: "Welcome to {{appName}}",
            discoverProcess: "Turn how work happens into a clear map. Interview your team, upload a file, or draw — every path leads to the same editable diagram.",
            discoverProcessTitle: "Build a diagram",
            generateDiagram: "Click here to create a diagram. Choose interview, upload, or draw in the next step.",
            generateDiagramTitle: "Create diagram",
            collectData: "Run an AI-led survey to enrich a process map or gather structured information from your team.",
            collectDataTitle: "Collect Data",
            analyzeOptimize: "Use AI-powered analysis to identify wastes, reduce costs, and enhance team efficiency.",
            analyzeOptimizeTitle: "AI Process Analysis",
            designFuture: "You have a business objective and want to know how to achieve it? Our AI project manager guides you from intent to action with a focus on driving impact.",
            designFutureTitle: "AI project management",
            recentProcesses: "To help you get started, we've pre-loaded a sample process so you can see the outcomes to expect.",
            recentProcessesTitle: "Sample Process"
        },
        processCreate: {
            pageName: "Process Creation",
            welcome: "Let's create your first process mapping project! This interface will guide you to document your processes and identify improvement opportunities.",
            welcomeTitle: "New Process Mapping Project",
            processName: "Enter a descriptive name for your process. Choose something clear that identifies the workflow you're mapping.",
            processNameTitle: "Process Name",
            processDescription: "Provide a brief description of what this process accomplishes. This helps team members understand the purpose.",
            processDescriptionTitle: "Process Description",
            processIndustry: "Select the industry that best matches your process. This helps our AI provide more relevant suggestions.",
            processIndustryTitle: "Industry Selection",
            processLanguage: "Choose the language for your process documentation. This affects the AI's responses and suggestions.",
            processLanguageTitle: "Language Selection",
            processType: "Select how you want to create your process. AI-guided interview or manual diagram creation.",
            processTypeTitle: "Creation Method",
            createButton: "Click here to create your process and start the mapping workflow. You'll be guided through the next steps.",
            createButtonTitle: "Create Process"
        },
        campaigns: {
            pageName: "Campaigns",
            welcome: "Welcome to the Campaigns workspace! Here you can design and manage your future processes with the help of artificial intelligence.",
            welcomeTitle: "Discover Campaigns",
            navigation: "This sidebar allows you to navigate between your different campaigns. You can create new campaigns or select an existing one.",
            navigationTitle: "Campaign Navigation",
            mainView: "This central area displays the main content of your selected campaign. This is where you'll interact with the design tools.",
            mainViewTitle: "Main View",
            aiAssistant: "The AI assistant helps you define objectives and design your future process. Ask questions and let it guide you!",
            aiAssistantTitle: "AI Assistant",
            sidebar: "This right sidebar contains contextual tools and information for your active campaign.",
            sidebarTitle: "Tools Panel",
            status: "Your campaign status shows you where you are in the design process and what the next steps are.",
            statusTitle: "Campaign Status",
            viewTabs: "These tabs allow you to switch between different views: AI Assistant, Processes, Collaborators, and Reports.",
            viewTabsTitle: "Navigation Tabs"
        },
        analysis: {
            pageName: "Analysis",
            welcome: "Welcome to AI-powered process and operations analysis! Here you can analyze your processes to identify wastes, reduce costs, and enhance team efficiency.",
            welcomeTitle: "AI Process Analysis",
            sidebar: "This sidebar allows you to manage your documents, create new analyses, and navigate between your saved analyses.",
            sidebarTitle: "Analysis Navigation",
            documents: "Here you can add documents and processes to analyze. Click 'New Document' to get started.",
            documentsTitle: "Document Management",
            reports: "This area displays your AI-generated analysis reports. Charts and visualizations help you understand your data.",
            reportsTitle: "Analysis Reports",
            suggestions: "These suggestions offer ready-to-use analyses. Click on a suggestion to launch the corresponding analysis.",
            suggestionsTitle: "Analysis Suggestions",
            input: "Use this area to ask specific questions about your data or request custom analyses from the AI.",
            inputTitle: "Input Area",
            charts: "The generated charts and visualizations help you better understand your processes and identify improvement opportunities.",
            chartsTitle: "Charts and Data",
            newDocumentTitle: "Document Management",
            newDocument: "Here you can add documents and processes to analyze. Click 'New Document' to get started."
        },
        flowchart: {
            pageName: "Flowchart Editor",
            welcome: "View and edit your AI-generated diagrams.",
            welcomeTitle: "Flowchart Editor",
            canvas: "Your diagram displays here. Click elements to modify them.",
            canvasTitle: "Diagram Canvas",
            processOwner: "Process owners have access to special commands to control who can edit and what can be changed.",
            processOwnerTitle: "Process Owner Commands",
            tools: "Use these tools to zoom, edit, and manage data layers.",
            toolsTitle: "Editing Tools",
            export: "Use this menu to export the diagram and interview transcripts in your preferred format.",
            exportTitle: "Export and Share",
            editMode: "Use drag and drop to add shapes from here to the drawing canvas.",
            editModeTitle: "Edit Mode",
            attributes: "Click a step then the Information icon to add attributes (costs, time, risks).",
            attributesTitle: "Add Attributes",
            analysis: "Get automatic AI insights and optimization recommendations.",
            analysisTitle: "AI Analysis"
        },
        admin: {
            pageName: "Admin Panel",
            welcome: "Welcome to your admin panel. This quick guide will introduce you to the main features for managing your workspace and tracking your usage.",
            welcomeTitle: "Admin Panel",
            overviewMerged: "This section provides a comprehensive overview of your dashboard: key metrics (active users, available credits), monthly consumption charts, and detailed credit management with quota and rollover. Monitor these indicators to optimize your usage and subscription plan.",
            overviewMergedTitle: "Overview and Metrics",
            actions: "This panel allows you to perform quick actions: top up credits, view history, and manage payments.",
            actionsTitle: "Quick Actions",
            subscription: "Manage your subscription, change plans, view invoices, and access the Stripe customer portal.",
            subscriptionTitle: "Subscription Management",
            administrators: "This tab allows you to manage your organization's administrators. You can add, modify, or remove admin rights to control who has access to advanced platform settings.",
            administratorsTitle: "Administrator Management",
            library: "Access your process library from this tab. Here you'll find all your mapping projects, diagrams, and documented processes. Easily organize, search, and manage all your workflows.",
            libraryTitle: "Process Library",
            users: "Invite new users, manage permissions, and track your team's activity from this panel.",
            usersTitle: "User Management"
        },
        onboarding: {
            pageName: "Login",
            welcome: "Welcome to {{appName}}! The AI for Operational Excellence. This guide is designed to help you quickly get started on the platform and explore its main features.",
            welcomeTitle: "Welcome to {{appName}}",
            loginForm: "Enter your work email and password to access the platform. Your credentials are secure and encrypted.",
            loginFormTitle: "Login Form",
            signupLink: "New to {{appName}}? Click here to create your account. You'll receive a verification email to activate your account.",
            signupLinkTitle: "Create Account",
            forgotPassword: "Forgot your password? Click this link to receive a secure password reset email.",
            forgotPasswordTitle: "Password Recovery",
            emailVerification: "Check your email inbox and click the confirmation link to activate your {{appName}} account.",
            emailVerificationTitle: "Email Verification"
        },
        library: {
            pageName: "Library",
            welcome: "Welcome to the Library! Organize your projects by client, program, or department. Create folders and move your projects for better organization.",
            welcomeTitle: "Library Management",
            projects: "Here you see all your projects. Click on a project to open it or use the contextual menu (3 dots) for more options.",
            projectsTitle: "Your Projects",
            folders: "Organize your projects in folders. By default, all projects are in the main folder.",
            foldersTitle: "Organization Folders",
            createFolder: "Click 'New Folder' to create a folder and organize your projects by category.",
            createFolderTitle: "Create Folder",
            moveProject: "Use the contextual menu (3 dots) on a project to move it to another folder.",
            moveProjectTitle: "Move Project",
            search: "Use the search function to quickly locate a specific project in your library.",
            searchTitle: "Project Search"
        },
        support: {
            pageName: "Support",
            welcome: "Easily access {{appName}} help and support. Find resources, contact assistance, and get help using the platform.",
            welcomeTitle: "Support and Help",
            helpMenu: "Click 'Help' in the header to access help resources, available from most pages.",
            helpMenuTitle: "Help Menu",
            contactForm: "Use the contact form to send us your questions or technical issues.",
            contactFormTitle: "Contact Form",
            supportEmail: "For direct support, contact us at {{supportEmail}} for personalized assistance.",
            supportEmailTitle: "Support Email"
        },
        participants: {
            pageName: "Participants Management",
            welcome: "Manage your interview participants.",
            welcomeTitle: "Participants Management",
            listAndStatus: "View all participants with their status (Invited, Active). Click the three dots (⋮) for more options.",
            listAndStatusTitle: "List and Status",
            menu: "Access options: replace, send reminders, or view transcripts.",
            menuTitle: "Management Options",
            replace: "Replace a participant if needed.",
            replaceTitle: "Replace",
            reminder: "Send reminders to restart incomplete interviews.",
            reminderTitle: "Reminders"
        },
        sampleProcess: {
            pageName: "Sample Process",
            welcome: "This sample Employee Onboarding process illustrates how {{appName}} captures steps, roles, and handoffs.",
            welcomeTitle: "Demonstration",
            interview: "Explore the Process Owner interview and 5 stakeholders.",
            interviewTitle: "Interview Phase",
            navigationMapping: "Click to see the AI-generated swimlane diagram.",
            navigationMappingTitle: "To Mapping",
            mapping: "5 lanes, 12 steps. Automatically generated mapping.",
            mappingTitle: "Swimlane Diagram",
            navigationAnalysis: "Click to see AI insights about the process.",
            navigationAnalysisTitle: "To Analysis",
            analysis: "Bottlenecks identified and optimization recommendations.",
            analysisTitle: "AI Analysis"
        },

        // =============================================================================
        // [APP GUIDANCE] Interactive tutorial for Employee Onboarding process
        // =============================================================================
        appGuidance: {
            welcome: "This sample Employee Onboarding process illustrates how {{appName}} captures steps, roles, and handoffs.",
            welcomeTitle: "Discover {{appName}}",
            interview: "The sidebar lets you access commands, see who's collaborating, and view outputs like maps and analysis.",
            interviewTitle: "Sidebar overview",
            navigationMapping: "Click to see the generated swimlane diagram.",
            navigationMappingTitle: "To Mapping",
            mapping: "No need to draw boxes manually! From the interview you just saw, {{appName}} has generated this complex visual flow. Click here to access the mapping.",
            mappingTitle: "Automated diagramming",
            navigationAnalysis: "Click to see the AI process analysis.",
            navigationAnalysisTitle: "To Analysis",
            analysisCta: "Bottlenecks identified and recommendations. Now create your own process!",
            analysisCtaTitle: "Analysis & Action",
            analysisCtaButton: "Create Your Own Process",
            analysisCtaButtonTitle: "Congratulations! You're now ready to use {{appName}} to transform your business operations.",
            interviewAction: "This is a hypothetical conversation between our AI interviewer and a user. Pay attention to the sequence and follow-ups.",
            interviewActionTitle: "AI Interviewer in action"
        }
    },

    popupMessage: {
        deleteOwnerMessages: "This action is irreversible. All messages from this point will be deleted. If you have invited contributors after this point, their interviews will also be permanently deleted.",
        deleteStakeholderMessages: "This action is irreversible. All messages from this point will be deleted.",
        finalConfirmation: "Final Confirmation",
        deleteProcess: "To confirm you want to delete all interviews and contributions, please type the following sentence: ",
        deleteInterviewsOf: "Delete interviews of ",
        typeThePhraseHere: "Type the sentence here",
        deleteAll: "Delete everything!",
        textDontMatch: "The texts do not match"
    },

    checklist: {
        setScope: "Set Scope",
        inviteStakeholders: "Invite Stakeholders",
        interviewsInProgress: "Interviews in progress",
        interviewsCompleted: "Interviews completed",
        discoveryCompleted: "Process maps available",
        mapTaskSequence: "Map task sequence",
        mapInterdependencies: "Map cross-role handoffs",
        identifyDecisionPoints: "Identify decision points",
        highlightIrritants: "Highlight irritants",
        reviewAlignment: "Review alignment",
        interviewCompleted: "Interview completed"
    },

    whatsNew: {
        badge: "What's new",
        period: "August 2026",
        title: "🚀 What's new on {{appName}} AI",
        subtitle: "A big batch of updates to help you map faster and work smarter.",
        cta: "Try {{appName}} Canvas",
        collectSetupTitle: "Easy to set up",
        collectSetupDesc: "Describe your objective and {{appName}} Collect designs the questions for you.",
        collectAdaptTitle: "Tailored to each stakeholder",
        collectAdaptDesc: "Questions adapt automatically based on role and previous answers. People only see what is relevant to them.",
        collectVoiceTitle: "Voice-enabled",
        collectVoiceDesc: "Stakeholders can respond by voice, making participation faster and more natural.",
        collectAvailable: "Available now for all users.",
        microsoftAuthTitle: "Microsoft Authentication",
        microsoftAuthDesc: "Sign in and invite colleagues securely using their Microsoft 365 or Azure AD accounts. Simplify access to {{appName}} for your entire organization.",
        coOwnerTitle: "Co-process owner",
        coOwnerDesc: "You can now share ownership of a process with a colleague. Head to your homepage, open the contextual menu on any process card, and grant extended rights in just a few clicks.",
        interfaceTitle: "Revamped interface",
        interfaceDesc: "A fresh new look with light mode enabled.",
        voiceTitle: "Voice mode for contributors",
        voiceDesc: "Conduct interviews hands-free with our new voice mode — you have to try it.",
        stakeholderTitle: "Smarter stakeholder detection",
        stakeholderDesc: "Additional stakeholders are now automatically detected from contributor interviews, and process owners are notified by email.",
        painPointTitle: "Pain points to Post-it notes",
        painPointDesc: "Pain points extracted from interviews are automatically loaded into Post-it notes, ready for you to act on.",
        canvasTitle: "Introducing {{appName}} Canvas",
        canvasDesc: "Draw your process maps manually from scratch, with full creative control.",
        bpmnTitle: "BPMN symbols",
        bpmnDesc: "Model your processes using standard BPMN notation.",
        onboardingTitle: "New onboarding journey",
        onboardingDesc: "New accounts get up to speed faster with a guided first experience.",
        homepageTitle: "Refreshed homepage",
        homepageDesc: "A new look and feel for a cleaner, more intuitive start.",
        teamControlsTitle: "Better team controls",
        teamControlsDesc: "Process owners can now manage teammates with greater precision.",
        searchTitle: "Smarter search",
        searchDesc: "Find processes by name or by the roles they feature."
    },

    microsoft: {
        marketplace_title: "Azure Marketplace",
        logo_alt: "{{appName}}",
        configuring: "Configuring your account...",
        thank_you: "Thank you for purchasing {{appName}} via Azure Marketplace.",
        shortMessage: "Simplified billing via your existing Azure account",
        activating: "Activating your subscription...",
        activating_retry: "Retrying activation ({{attempt}}/{{max}})…",
        success: "{{credits}} credits added to your account!",
        activation_success: "Activation Successful!",
        sso_required_title: "Sign in to activate",
        connecting_famla: "Connecting to your {{appName}} account...",
        integration_label: "Integration",
        credits_added: "credits added",
        purchaseSuccessToast: "{{credits}} credits added via Azure Marketplace!",
        redirecting: "Redirecting to your dashboard...",
        activation_error: "Activation Error",
        contact_support: "Contact Support",
        auto_redirect: "You will be automatically redirected.",
        click_here: "click here",
        free_starter_awaiting_sso: "Sign in with Microsoft to activate your Free subscription. Upgrade to Plus for more credits.",
        free_starter_upgrade_message: "Your Free plan is active. Upgrade to Plus for more credits and features.",
        free_starter_redirecting: "Redirecting to your dashboard...",
        workspace_required: "Sign in with Microsoft SSO to create your workspace, then retry activation.",
        tenant_mismatch: "The Microsoft account does not match the organization that purchased this offer.",
        retry_activation: "Retry activation",
        connect_microsoft: "Sign in with Microsoft",
        reconnect_microsoft: "Sign in with the correct account",
        view_plans: "View plans",
        error: {
            no_token: "Microsoft token is missing",
            not_authenticated: "You must be logged in",
            activation_failed: "Failed to activate subscription. Please contact support.",
            free_starter_already_claimed: "You have already activated the Free Starter plan. Upgrade to Plus for more credits!",
            activation_retry: "Activation is taking longer than expected. Please try again in a moment.",
            company_mismatch: "Your session company does not match this subscription.",
            token_expired: "The Marketplace token is invalid or has expired. Start again from Azure Marketplace or contact support."
        }
    },

    office: {
        auth: {
            signInPrompt: "Sign in with your Microsoft account to use Famla.",
            signInButton: "Sign in with Microsoft",
            signInRequired: "Please sign in with Microsoft to continue.",
            signInPromptEmail: "Sign in with your Famla email and password.",
            signInButtonEmail: "Sign in with email",
            signInWithMicrosoftSecondary: "Sign in with Microsoft",
            emailDialogTitle: "Sign in to Famla",
            emailDialogSubtitle: "Use your Famla email and password.",
            emailNotVerified: "Please verify your email address before signing in.",
            corporateSsoRequired: "Corporate accounts must sign in through the SSO portal.",
            emailSignInFailed: "Sign-in failed. Please try again."
        },
        sidebar: {
            notAvailable: "Office not available",
            notAvailableDesc: "This sidebar must be opened from within Microsoft Office.",
            readingContext: "Reading context",
            loading: "Loading...",
            noContext: "No context available",
            askAboutProcess: "Ask about this process",
            flagPainPoint: "Flag a pain point",
            emptyThread: "Select an action above to start.",
            emptyThreadHint: "Ask a question or flag a pain point about this email.",
            inputPlaceholder: "Ask a question or describe an irritant",
            send: "Send",
            generateMap: "Generate a full process map in Famla",
            handoffLoading: "Creating session...",
            handoffError: "Failed to create handoff session",
            desktopLaunching: "Opening Microsoft desktop app...",
            desktopLaunchBlocked: "Could not open the desktop app automatically. Please open it manually.",
            modeQa: "Ask me anything about this process.",
            modeAndon: "Describe the issue or pain point you encountered.",
            mapWelcome: "Captured this context. I'll hand off to the Famla web app and pre-load the document-to-map generator.",
            andonWelcome: "You're flagging a pain point. In one line, what went wrong here?",
            contextCapturedTitle: "Context captured",
            contextCapturedBody: "Opening the Famla web app with the document-to-map generator pre-loaded.",
            openWebApp: "Open Famla web app",
            andonConfirm: "Your pain point has been flagged. The process owner and administrators have been notified via Teams and email.",
            andonSuccess: "Pain point flagged successfully",
            error: "An error occurred. Please try again.",
            errorToast: "Request failed",
            sourceChipClick: "Opening source in new tab...",
            generalKnowledge: "Based on general practice, not a specific process record: "
        },
        handoff: {
            loading: "Loading your Office context...",
            errorTitle: "Handoff session unavailable",
            missingSession: "No handoff session was provided.",
            errorDesc: "This session may have expired or already been used.",
            authRequired: "Please sign in to Famla to load this handoff session.",
            title: "Create a process map from Office",
            subtitle: "Your {{hostApp}} context has been imported. Review and complete the form below.",
            returnToHost: "Return to {{hostApp}}",
            returnChoose: "Return to {{hostApp}}",
            returnWeb: "Open in browser",
            returnDesktop: "Open desktop app",
            desktopLaunching: "Opening {{hostApp}} desktop...",
            desktopTryAnyway: "{{hostApp}} desktop may not be installed on this system. If nothing opens, use the browser option.",
            desktopHint: "May require {{hostApp}} desktop (Windows/Mac)",
            desktopHintSupported: "Opens {{hostApp}} installed on your computer",
            threadContext: "Office conversation"
        }
    },

    andon: {
        hub: {
            title: "Andon Flags",
            loading: "Loading...",
            empty: "No flags have been raised yet.",
            loadError: "Failed to load Andon flags",
            colOrigin: "Origin",
            colUser: "User",
            colMessage: "Message",
            colStatus: "Status",
            colDate: "Date",
            view: "View",
            status: {
                pending: "Pending",
                acknowledged: "Acknowledged",
                resolved: "Resolved"
            }
        },
        detail: {
            title: "Flag Details",
            backToList: "Back to Andon Hub",
            loading: "Loading...",
            notFound: "Flag not found.",
            loadError: "Failed to load flag details",
            status: "Status",
            origin: "Origin (host app)",
            user: "Reported by",
            message: "Message",
            context: "Context",
            subject: "Subject",
            timestamps: "Timestamps",
            created: "Created",
            acknowledged: "Acknowledged",
            resolved: "Resolved",
            notified: "Notifications sent",
            resolutionNote: "Resolution note",
            acknowledgeBtn: "Acknowledge",
            acknowledgeSuccess: "Flag acknowledged",
            acknowledgeError: "Failed to acknowledge",
            resolveBtn: "Resolve",
            resolveSuccess: "Flag resolved",
            resolveError: "Failed to resolve",
            resolveNoteRequired: "Please add a resolution note",
            resolveNotePlaceholder: "Add a resolution note..."
        }
    }

}

export default en
